<template>
  <div>
    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility6"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Mark Status</h5>
        <div class="d-flex align-items-center">
          <b-button
            variant="outline-primary"
            class="btn-icon mr-50"
            size="sm"
            v-b-tooltip.hover.top
            title="Status History"
            @click="openStudentHolidayHistory()"
          >
            <feather-icon icon="ClockIcon" size="16" />
          </b-button>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="visibility6 = false"
          />
        </div>
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1">
          <b-col md="12">
            <b-form-group label="Status" ref="hol_status">
              <v-select
                v-model="holiObj.statusType"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="markStatusOptions"
                :reduce="(val) => val.value"
                label="label"
                :clearable="false"
                placeholder="Select status"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" v-if="false">
            <b-form-group
              label="Department"
              invalid-feedback="Department is required."
              ref="hol_dep"
            >
              <v-select
                multiple
                :closeOnSelect="false"
                v-model="holiObj.departmentIDs"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="departments"
                :reduce="(val) => val.id"
                label="name"
                :clearable="false"
                @input="setHoliDept()"
                ref="hol_dep"
                placeholder="Select department"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Select Class"
              :invalid-feedback="$t('Class is required')"
              ref="hol_class"
            >
              <v-select
                multiple
                :closeOnSelect="false"
                v-model="holiObj.clsIDs"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="classesOptions"
                :clearable="false"
                label="name"
                :reduce="(val) => val.id"
                placeholder="Select class"
                @input="setHoliClass()"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Select Section"
              invalid-feedback="Section is required"
              ref="hol_section"
            >
              <v-select
                multiple
                :closeOnSelect="false"
                v-model="holiObj.secIDs"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="holiSecOptions"
                :reduce="(val) => val.id"
                :clearable="false"
                label="section"
                placeholder="Select section"
                @input="setHoliSections()"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Date From"
              invalid-feedback=" date is required."
              ref="hol_dateF"
            >
              <flat-pickr
                ref="hol_dateF"
                :config="config"
                v-model="holiObj.dtFrom"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Date Till"
              invalid-feedback=" date is required."
              ref="hol_dateT"
            >
              <flat-pickr
                ref="hol_dateT"
                :config="config"
                v-model="holiObj.dtTo"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" v-if="holiObj.statusType !== 'off'">
            <b-form-group label="Reason" ref="hol_reason">
              <b-form-input
                v-model.trim="holiObj.reason"
                placeholder="Enter reason (optional)"
              />
            </b-form-group>
          </b-col>

          <b-col class="mt-1" md="12">
            <b-button
              variant="success"
              @click="markAttendanceStatus()"
              :disabled="marking"
              block
            >
              <b-spinner v-if="marking" small type="grow" />
              <span v-else>{{ $t("Save") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <!-- Student Holiday History Modal -->
    <b-modal
      v-model="studentHolidayHistoryVisible"
      hide-header
      hide-footer
      size="xl"
      centered
      no-close-on-backdrop
      body-class="p-0"
      content-class="holiday-history-modal"
    >
      <div class="hh-modal">
        <div class="hh-header">
          <div class="hh-header-left">
            <div class="hh-header-icon">
              <feather-icon icon="ClockIcon" size="18" />
            </div>
            <div>
              <div class="hh-header-title">Status History</div>
              <div class="hh-header-sub">
                View and remove holidays, exam leave, study leave, and off marks
              </div>
            </div>
          </div>
          <button
            type="button"
            class="hh-close-btn"
            @click="studentHolidayHistoryVisible = false"
          >
            <feather-icon icon="XIcon" size="16" />
          </button>
        </div>

        <div class="hh-filters">
          <div class="hh-filter-field">
            <label>Date From</label>
            <flat-pickr
              v-model="studentHolidayHistoryFilters.dtFrom"
              :config="config"
              class="form-control hh-date-input"
              :placeholder="$t('Select Date')"
            />
          </div>
          <div class="hh-filter-field">
            <label>Date Till</label>
            <flat-pickr
              v-model="studentHolidayHistoryFilters.dtTo"
              :config="config"
              class="form-control hh-date-input"
              :placeholder="$t('Select Date')"
            />
          </div>
          <div class="hh-filter-field">
            <label>Status</label>
            <v-select
              v-model="studentHolidayHistoryFilters.status"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="studentHolidayHistoryStatusFilterOptions"
              :reduce="(val) => val.value"
              label="label"
              :clearable="false"
              placeholder="All types"
            />
          </div>
          <div class="hh-filter-actions">
            <b-button
              variant="primary"
              class="hh-btn-search"
              :disabled="studentHolidayHistoryLoading"
              @click="loadStudentHolidayHistory(1)"
            >
              <b-spinner
                v-if="studentHolidayHistoryLoading"
                small
                type="grow"
              />
              <template v-else>
                <feather-icon icon="SearchIcon" size="14" class="mr-50" />
                Search
              </template>
            </b-button>
            <b-button
              variant="flat-secondary"
              class="hh-btn-clear"
              :disabled="studentHolidayHistoryLoading"
              @click="resetStudentHolidayHistoryFilters()"
            >
              Clear
            </b-button>
          </div>
        </div>

        <div class="hh-table-wrap">
          <b-table
            :items="studentHolidayHistoryItems"
            :fields="visibleStudentHolidayHistoryFields"
            :busy="studentHolidayHistoryLoading"
            show-empty
            responsive
            hover
            borderless
            class="holiday-history-table"
          >
            <template #table-busy>
              <div class="hh-busy">
                <b-spinner variant="primary" />
              </div>
            </template>
            <template #empty>
              <div class="hh-empty">
                <feather-icon icon="CalendarIcon" size="28" class="mb-50" />
                <div>No records found</div>
              </div>
            </template>
            <template #cell(campusName)="data">
              <span class="hh-campus">{{
                formatHolidayHistoryCampus(data.item)
              }}</span>
            </template>
            <template #cell(dtFrom)="data">
              <span class="hh-date-chip">{{
                formatStudentHolidayDate(data.item.dtFrom)
              }}</span>
            </template>
            <template #cell(dtTo)="data">
              <span class="hh-date-chip">{{
                formatStudentHolidayDate(data.item.dtTo)
              }}</span>
            </template>
            <template #cell(status)="data">
              <b-badge
                pill
                :variant="
                  holidayHistoryStatusVariant(
                    resolveHolidayHistoryRowStatus(data.item)
                  )
                "
                class="hh-status-badge"
              >
                {{
                  holidayHistoryStatusLabel(
                    resolveHolidayHistoryRowStatus(data.item)
                  )
                }}
              </b-badge>
            </template>
            <template #cell(reason)="data">
              <span class="hh-reason">{{ data.item.reason || "—" }}</span>
            </template>
            <template #cell(clsIDs)="data">
              <span class="hh-dept-pill">{{
                formatStudentHolidayClasses(data.item.clsIDs)
              }}</span>
            </template>
            <template #cell(secIDs)="data">
              <span class="hh-dept-pill">{{
                formatStudentHolidaySections(data.item.secIDs)
              }}</span>
            </template>
            <template #cell(createdByName)="data">
              {{
                data.item.createdByName ||
                data.item.createdBy ||
                data.item.userName ||
                "—"
              }}
            </template>
            <template #cell(createdAt)="data">
              <span class="hh-muted">{{
                formatStudentHolidayDateTime(data.item.createdAt)
              }}</span>
            </template>
            <template #cell(actions)="data">
              <div class="hh-actions">
                <button
                  type="button"
                  class="hh-del-btn"
                  :disabled="
                    studentHolidayHistoryDeletingId ===
                    holidayHistoryRowId(data.item)
                  "
                  v-b-tooltip.hover.top
                  title="Delete"
                  @click="deleteStudentHolidayHistory(data.item)"
                >
                  <b-spinner
                    v-if="
                      studentHolidayHistoryDeletingId ===
                      holidayHistoryRowId(data.item)
                    "
                    small
                    type="grow"
                  />
                  <feather-icon v-else icon="Trash2Icon" size="15" />
                </button>
              </div>
            </template>
          </b-table>
        </div>

        <div v-if="studentHolidayHistoryTotal > 0" class="hh-footer">
          <span class="hh-footer-count">
            Showing
            <strong>{{ studentHolidayHistoryRange.start }}</strong>
            –
            <strong>{{ studentHolidayHistoryRange.end }}</strong>
            of
            <strong>{{ studentHolidayHistoryTotal }}</strong>
          </span>
          <b-pagination
            v-if="
              studentHolidayHistoryTotal > studentHolidayHistoryPageSize
            "
            v-model="studentHolidayHistoryPage"
            :total-rows="studentHolidayHistoryTotal"
            :per-page="studentHolidayHistoryPageSize"
            size="sm"
            class="mb-0 hh-pagination"
            @input="loadStudentHolidayHistory"
          />
        </div>
      </div>
    </b-modal>

    <!-- Holiday Summary Modal -->
    <b-modal
      v-model="holidaySummaryVisible"
      hide-header
      hide-footer
      centered
      size="lg"
      body-class="p-0"
    >
      <div v-if="holidaySummary" class="hs-modal">
        <div class="hs-header">
          <div class="hs-header-left">
            <div
              class="hs-header-icon"
              :class="{ 'hs-header-icon--warn': holidaySummaryHasWarn }"
            >
              <feather-icon
                :icon="
                  holidaySummaryHasWarn
                    ? 'AlertTriangleIcon'
                    : 'CheckCircleIcon'
                "
                size="20"
              />
            </div>
            <div>
              <div class="hs-header-title">Status Summary</div>
              <div class="hs-header-meta">
                <span class="hs-meta-badge">
                  <feather-icon icon="CalendarIcon" size="11" />
                  {{ holidaySummary.dtFrom }} → {{ holidaySummary.dtTo }}
                </span>
                <span
                  class="hs-meta-badge hs-meta-badge--reason"
                  v-if="holidaySummary.reason"
                >
                  <feather-icon icon="TagIcon" size="11" />
                  {{ holidaySummary.reason }}
                </span>
                <span
                  v-if="holidaySummary.totalStudents != null"
                  class="hs-meta-badge"
                >
                  <feather-icon icon="UsersIcon" size="11" />
                  {{ holidaySummary.totalStudents }} students
                </span>
                <span
                  v-if="holidaySummary.totalDates != null"
                  class="hs-meta-badge"
                >
                  {{ holidaySummary.totalDates }} day(s)
                </span>
              </div>
            </div>
          </div>
          <button class="hs-close-btn" @click="holidaySummaryVisible = false">
            <feather-icon icon="XIcon" size="16" />
          </button>
        </div>

        <div
          v-if="holidaySummary.message"
          class="hs-message"
          :class="{ 'hs-message--warn': holidaySummaryHasWarn }"
        >
          <feather-icon
            :icon="holidaySummaryHasWarn ? 'AlertCircleIcon' : 'InfoIcon'"
            size="14"
          />
          <span>{{ holidaySummary.message }}</span>
        </div>

        <div class="hs-stats">
          <div class="hs-stat hs-stat--green">
            <div class="hs-stat-num">{{ holidaySummary.created || 0 }}</div>
            <div class="hs-stat-lbl">Created</div>
          </div>
          <div class="hs-stat hs-stat--blue">
            <div class="hs-stat-num">{{ holidaySummary.updated || 0 }}</div>
            <div class="hs-stat-lbl">Updated</div>
          </div>
          <div class="hs-stat hs-stat--orange">
            <div class="hs-stat-num">
              {{ holidaySummary.alreadyHoliday || 0 }}
            </div>
            <div class="hs-stat-lbl">Already</div>
          </div>
          <div class="hs-stat hs-stat--purple">
            <div class="hs-stat-num">{{ holidaySummaryTotalProcessed }}</div>
            <div class="hs-stat-lbl">Total Processed</div>
          </div>
        </div>

        <div class="hs-footer">
          <b-button
            variant="primary"
            @click="holidaySummaryVisible = false"
            class="hs-done-btn"
          >
            Done
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Student Availability / Days Settings -->
    <b-sidebar
      id="sidebar-days-settings"
      bg-variant="white"
      v-model="visibilityDays"
      sidebar-class="sidebar-days-settings"
      right
      no-header
      backdrop
      shadow
      @shown="loadStudentAvailability()"
    >
      <div class="days-settings">
        <div class="days-settings__header">
          <div>
            <h5 class="mb-0">Days Settings</h5>
            <small class="text-muted"
              >Configure off days by class & section</small
            >
          </div>
          <feather-icon
            class="cursor-pointer text-muted"
            icon="XIcon"
            size="18"
            @click="visibilityDays = false"
          />
        </div>

        <div class="days-settings__body">
          <div class="days-settings__card">
            <div class="days-settings__card-title">
              {{ availObj.id > 0 ? "Edit Rule" : "Add Rule" }}
            </div>

            <b-form @submit.prevent>
              <b-form-group label="Class" class="mb-1">
                <v-select
                  multiple
                  :closeOnSelect="false"
                  v-model="availObj.classIDs"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="classesOptions"
                  :clearable="false"
                  label="name"
                  :reduce="(val) => val.id"
                  placeholder="Select class"
                  @input="setAvailClass()"
                />
              </b-form-group>

              <b-form-group label="Section" class="mb-1">
                <v-select
                  multiple
                  :closeOnSelect="false"
                  v-model="availObj.sectionIDs"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="availSecOptions"
                  :reduce="(val) => val.id"
                  :clearable="false"
                  label="section"
                  placeholder="Select section"
                  @input="setAvailSections()"
                />
              </b-form-group>

              <b-form-group label="Days" class="mb-1">
                <v-select
                  multiple
                  :closeOnSelect="false"
                  v-model="availObj.days"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="weekdayOptions"
                  :clearable="false"
                  placeholder="Select days"
                />
              </b-form-group>

              <div
                v-if="
                  (availObj.id > 0 && rights.edit) ||
                  (availObj.id === 0 && (rights.add || rights.edit))
                "
                class="d-flex"
                style="gap: 8px"
              >
                <b-button
                  variant="primary"
                  class="flex-grow-1"
                  :disabled="availSaving"
                  @click="saveStudentAvailability()"
                >
                  <b-spinner v-if="availSaving" small type="grow" />
                  <span v-else>{{
                    availObj.id > 0 ? "Update Rule" : "Save Rule"
                  }}</span>
                </b-button>
                <b-button
                  v-if="availObj.id > 0"
                  variant="outline-secondary"
                  :disabled="availSaving"
                  @click="resetAvailForm()"
                >
                  Cancel
                </b-button>
              </div>
            </b-form>
          </div>

          <div class="days-settings__list-head">
            <div>
              <div class="days-settings__card-title mb-0">Saved Rules</div>
              <small class="text-muted"
                >{{ availTotal || availList.length }} rule(s)</small
              >
            </div>
            <b-button
              size="sm"
              variant="outline-primary"
              :disabled="availLoading"
              @click="loadStudentAvailability()"
            >
              <feather-icon
                v-if="!availLoading"
                icon="RefreshCwIcon"
                size="14"
                class="mr-25"
              />
              <b-spinner v-else small type="grow" />
              Refresh
            </b-button>
          </div>

          <!-- Skeleton loading — Days Settings only -->
          <div v-if="availLoading" class="days-settings-skeleton">
            <div
              v-for="n in 4"
              :key="'avail-skel-' + n"
              class="days-settings-skeleton__card"
            >
              <div class="days-settings-skeleton__top">
                <div class="days-settings-skeleton__meta-grid">
                  <div
                    class="days-settings-skeleton__bar days-settings-skeleton__bar--meta"
                  ></div>
                  <div
                    class="days-settings-skeleton__bar days-settings-skeleton__bar--meta"
                  ></div>
                </div>
                <div class="days-settings-skeleton__actions">
                  <div
                    class="days-settings-skeleton__bar days-settings-skeleton__bar--icon"
                  ></div>
                  <div
                    class="days-settings-skeleton__bar days-settings-skeleton__bar--icon"
                  ></div>
                </div>
              </div>
              <div class="days-settings-skeleton__chips">
                <div
                  v-for="c in 3"
                  :key="'chip-' + n + '-' + c"
                  class="days-settings-skeleton__bar days-settings-skeleton__bar--chip"
                ></div>
              </div>
            </div>
          </div>

          <div v-else-if="!availList.length" class="days-settings__empty">
            <feather-icon icon="InboxIcon" size="28" class="mb-50 text-muted" />
            <div class="font-weight-bold">No rules yet</div>
            <small class="text-muted"
              >Save a class/section + days rule above</small
            >
          </div>

          <template v-else>
            <div
              v-for="item in availList"
              :key="'avail-' + item.id"
              class="days-settings__rule"
            >
              <div class="days-settings__rule-top">
                <div class="days-settings__meta-grid">
                  <div class="days-settings__meta-card">
                    <span class="days-settings__meta-label">Class</span>
                    <span class="days-settings__meta-value">{{
                      formatAvailClasses(item)
                    }}</span>
                  </div>
                  <div class="days-settings__meta-card">
                    <span class="days-settings__meta-label">Section</span>
                    <span class="days-settings__meta-value">{{
                      formatAvailSections(item)
                    }}</span>
                  </div>
                </div>

                <div
                  v-if="rights.edit || rights.delete"
                  class="days-settings__actions days-settings__actions--icons"
                >
                  <b-button
                    v-if="rights.edit"
                    size="sm"
                    variant="outline-primary"
                    class="btn-icon days-settings__icon-btn"
                    v-b-tooltip.hover.top
                    title="Edit"
                    @click="editStudentAvailability(item)"
                  >
                    <feather-icon icon="EditIcon" size="14" />
                  </b-button>
                  <b-button
                    v-if="rights.delete"
                    size="sm"
                    variant="outline-danger"
                    class="btn-icon days-settings__icon-btn"
                    v-b-tooltip.hover.top
                    title="Delete"
                    :disabled="availDeleting === item.id"
                    @click="deleteStudentAvailability(item)"
                  >
                    <b-spinner
                      v-if="availDeleting === item.id"
                      small
                      type="grow"
                    />
                    <feather-icon v-else icon="Trash2Icon" size="14" />
                  </b-button>
                </div>
              </div>

              <div class="days-settings__days-wrap">
                <span
                  v-for="day in splitAvailDays(item.days)"
                  :key="'day-' + item.id + '-' + day"
                  class="days-settings__day"
                >
                  {{ day.slice(0, 3) }}
                </span>
                <span
                  v-if="!splitAvailDays(item.days).length"
                  class="days-settings__day days-settings__day--empty"
                >
                  No days
                </span>
              </div>
            </div>
          </template>

          <div
            v-if="!availLoading && availTotal > availPageSize"
            class="days-settings__pager"
          >
            <b-button
              size="sm"
              variant="outline-secondary"
              :disabled="availPage <= 1 || availLoading"
              @click="changeAvailPage(availPage - 1)"
            >
              Prev
            </b-button>
            <small>Page {{ availPage }}</small>
            <b-button
              size="sm"
              variant="outline-secondary"
              :disabled="
                availPage * availPageSize >= availTotal || availLoading
              "
              @click="changeAvailPage(availPage + 1)"
            >
              Next
            </b-button>
          </div>
        </div>
      </div>
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility2"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Send Messsage</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility2 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="pt-1 pb-1" style="align-items: center">
          <b-col md="12">
            <b-form-group
              label="Select Class"
              :invalid-feedback="$t('Class is required')"
              ref="msg_class"
            >
              <v-select
                ref="msg_class"
                multiple
                :closeOnSelect="false"
                v-model="msgClass"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="classesOptions"
                :clearable="false"
                label="name"
                :reduce="(val) => val.id"
                @input="FillMsgSections()"
                placeholder="Select class"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" v-if="msgClass[0] != 0">
            <b-form-group
              label="Select Section"
              invalid-feedback="Section is required"
              ref="msg_section"
            >
              <v-select
                multiple
                :closeOnSelect="false"
                v-model="msgSection"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="msgSecOptions"
                :reduce="(val) => val.id"
                :clearable="false"
                @input="checkMsgSections()"
                ref="msg_section"
                label="section"
                placeholder="Select section"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Date"
              invalid-feedback=" date is required."
              ref="msg_date"
            >
              <flat-pickr
                ref="msg_date"
                :config="config"
                v-model="msgObj.dt"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" class="mt-1">
            <b-form-group
              label="Select Status"
              invalid-feedback="status is required."
              ref="msg_status"
            >
              <v-select
                ref="msg_status"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                v-model="msgObj.status"
                :options="statusOptions"
                :reduce="(opt) => opt.value"
                label="name"
                placeholder="select status"
              />
            </b-form-group>
          </b-col>
          <b-col class="mt-1" md="12">
            <b-button
              variant="success"
              @click="saveMessage()"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-else>Send Message</span>
            </b-button>
          </b-col>
          <b-col class="mt-1" md="12">
            <b-button
              variant="primary"
              @click="sendNotificationFromSidebar()"
              :disabled="iNotification"
              block
            >
              <b-spinner v-if="iNotification" small type="grow" />
              <span v-else>Send Notification</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility5"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Settings</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility5 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="pt-1 pb-1">
          <b-col
            v-if="checkInObj"
            class="d-flex align-items-center justify-content-between mb-1"
            md="12"
          >
            <h4 class="mr-1">Show Time In</h4>
            <b-form-checkbox v-model="checkInObj.valueBool" switch />
          </b-col>
          <b-col
            v-if="checkOutObj"
            class="d-flex align-items-center justify-content-between mb-1"
            md="12"
          >
            <h4 class="mr-1">Show Time Out</h4>
            <b-form-checkbox v-model="checkOutObj.valueBool" switch />
          </b-col>

          <b-col class="mt-1" md="12">
            <b-button
              variant="success"
              @click="saveChecks()"
              :disabled="savingCh"
              block
            >
              <b-spinner v-if="savingCh" small type="grow" />
              <span v-else> Save </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility3"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Reports</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility3 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="pt-1 pb-1" style="align-items: center">
          <b-col md="12">
            <b-form-group
              label="Select Class"
              :invalid-feedback="$t('Class is required')"
              ref="rep_class"
            >
              <v-select
                ref="rep_class"
                multiple
                :closeOnSelect="false"
                v-model="repClass"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="classesOptions"
                :clearable="false"
                label="name"
                :reduce="(val) => val.id"
                @input="FillRepSections()"
                placeholder="Select class"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" v-if="repClass[0] != 0">
            <b-form-group
              label="Select Section"
              invalid-feedback="Section is required"
              ref="rep_section"
            >
              <v-select
                multiple
                :closeOnSelect="false"
                v-model="repSection"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="repSecOptions"
                :reduce="(val) => val.id"
                :clearable="false"
                @input="checkRepSections()"
                ref="rep_section"
                label="section"
                placeholder="Select section"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Date"
              invalid-feedback=" date is required."
              ref="rep_date"
            >
              <flat-pickr
                ref="rep_date"
                :config="config2"
                v-model="repDate"
                class="form-control"
                :placeholder="$t('Select Date')"
                @on-change="setRepDate"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" class="mt-1">
            <b-form-group
              label="Select Status"
              invalid-feedback="status is required."
              ref="rep_status"
            >
              <v-select
                multiple
                :closeOnSelect="false"
                ref="rep_status"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                v-model="repObj.status"
                :options="statusOptions"
                :reduce="(opt) => opt.value"
                label="name"
                placeholder="select status"
                @input="setStatus()"
              />
            </b-form-group>
          </b-col>
          <b-col class="mt-1" md="12">
            <b-button
              variant="success"
              @click="getReport()"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-else>Show</span>
            </b-button>
          </b-col>
          <b-col class="mt-1" md="12">
            <b-button
              variant="success"
              @click="getSheet()"
              :disabled="sheetLoading"
              block
            >
              <b-spinner v-if="sheetLoading" small type="grow" />
              <span v-else>Attendance Sheet</span>
            </b-button>
          </b-col>
          <b-col class="mt-1" md="12">
            <b-button
              variant="warning"
              @click="exportReport()"
              :disabled="exporting"
              block
            >
              <b-spinner v-if="exporting" small type="grow" />
              <span v-else>Export</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility4"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Smart Attendance</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility4 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="pt-1 pb-1">
          <b-col md="12">
            <b-form-group
              label="Date"
              invalid-feedback="Date is required"
              ref="sm_date"
            >
              <flat-pickr
                :config="config2"
                v-model="smartObj.dt"
                class="form-control"
                :placeholder="$t('Select Date')"
                @on-change="setSmartDate"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Gr Numbers"
              invalid-feedback="Please enter gr separated by space"
              ref="grs"
            >
              <b-form-textarea
                ref="grs"
                placeholder="Enter gr numbers seperated by space"
                v-model="smartObj.gr"
                rows="4"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col md="12" class="mt-1">
            <b-form-group
              label="Status"
              invalid-feedback="Status is required."
              ref="sm_status"
            >
              <v-select
                ref="sm_status"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                v-model="smartObj.status"
                :options="smartOptions"
                :reduce="(opt) => opt.value"
                label="name"
                placeholder="select status"
              />
            </b-form-group>
          </b-col>
          <b-col class="mt-1" md="12">
            <b-button
              variant="success"
              @click="saveSmart()"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-else> Save </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <!-- Notification Confirmation Modal -->
    <b-modal
      v-model="showNotificationModal"
      title="Send Notification"
      centered
      @hidden="notificationStatus = 'A'"
    >
      <div class="text-left">
        <p
          style="
            margin-bottom: 20px;
            font-size: 15px;
            color: #5e5873;
            line-height: 1.6;
          "
        >
          You are about to send attendance notification and apply attendance.
        </p>
        <b-form-group label="Select Status" label-for="notification-status">
          <v-select
            id="notification-status"
            v-model="notificationStatus"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :clearable="false"
            :options="statusOptions"
            :reduce="(opt) => opt.value"
            label="name"
            placeholder="Select status"
          />
        </b-form-group>
        <p
          style="
            margin-top: 20px;
            font-size: 14px;
            color: #6e6b7b;
            line-height: 1.5;
          "
        >
          Are you sure you want to proceed?
        </p>
      </div>
      <template #modal-footer>
        <b-button variant="secondary" @click="showNotificationModal = false">
          Cancel
        </b-button>
        <b-button
          variant="primary"
          @click="confirmSendNotification"
          :disabled="iNotification"
        >
          <b-spinner v-if="iNotification" small type="grow" />
          <span v-else>Yes, Send Notification</span>
        </b-button>
      </template>
    </b-modal>

    <!-- Update Modal -->
    <b-modal
      id="modal-update"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      no-close-on-backdrop
      title="Update Settings"
    >
      <b-form @submit.prevent>
        <b-row class="pt-1 pb-1">
          <b-col
            class="d-flex align-items-center justify-content-between mb-1"
            md="12"
          >
            <h4 class="mr-1">Friday</h4>
            <b-form-checkbox v-model="updateObj.friday" switch />
          </b-col>
          <b-col
            class="d-flex align-items-center justify-content-between mb-1"
            md="12"
          >
            <h4 class="mr-1">Saturday-Sunday</h4>
            <b-form-checkbox v-model="updateObj.saturdaySunday" switch />
          </b-col>
        </b-row>

        <!-- Friday specific fields -->
        <div v-if="updateObj.friday">
          <b-row class="mt-1">
            <b-col md="12">
              <b-form-group
                label="Select Class"
                :invalid-feedback="$t('Class is required')"
                ref="update_class"
              >
                <v-select
                  multiple
                  :closeOnSelect="false"
                  v-model="updateObj.clsIDs"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="classesOptions"
                  :clearable="false"
                  label="name"
                  :reduce="(val) => val.id"
                  placeholder="Select class"
                  @input="setUpdateClass()"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="Date"
                invalid-feedback="date is required."
                ref="update_date"
              >
                <flat-pickr
                  ref="update_date"
                  :config="config"
                  v-model="updateObj.date"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <!-- Saturday-Sunday specific fields -->
        <div v-if="updateObj.saturdaySunday">
          <b-row class="mt-1">
            <b-col md="12">
              <b-form-group
                label="Date"
                invalid-feedback="date is required."
                ref="update_date_ss"
              >
                <flat-pickr
                  ref="update_date_ss"
                  :config="config"
                  v-model="updateObj.dateSS"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <b-row class="mt-1">
          <b-col class="d-flex justify-content-end">
            <b-button
              @click="saveUpdate()"
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="success"
              :disabled="savingUpdate"
            >
              <b-spinner v-if="savingUpdate" small type="grow" />
              <span v-else class="align-middle">Save</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <!-- Details -->
    <b-row v-if="showreport">
      <b-sidebar
        id="sidebar-right"
        ref="mySidebar"
        bg-variant="white"
        v-model="editAtt"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">Edit Attendance</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hideAtt()"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row class="pt-1 pb-1" style="align-items: center">
            <b-col md="3">
              <b-img
                v-if="attendance.picture == null || attendance.picture == ''"
                src="https://cdn.cloudious.net/file-1677912450367-333289208.png"
                style="width: 100px; height: 100px; object-fit: cover"
              />
              <b-img
                v-else
                :src="attendance.picture"
                style="
                  width: 100px;
                  height: 100px;
                  object-fit: cover;
                  border-radius: 50%;
                "
              />
            </b-col>
            <b-col md="8" class="ml-1">
              <h5>Name: {{ attendance.name }}</h5>
              <h5>Father Name: {{ attendance.father_name }}</h5>
              <h5>Gr# {{ attendance.grNo }}</h5>
            </b-col>
            <b-col md="12" class="mt-1">
              <b-form-group
                label="Time"
                invalid-feedback="time is required."
                ref="time"
              >
                <flat-pickr
                  v-model="timePicker"
                  class="form-control"
                  :config="{
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: 'h:i:K',
                  }"
                  @input="setTime()"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="Date"
                invalid-feedback="date is required."
                ref="date"
              >
                <flat-pickr
                  ref="date"
                  :config="config2"
                  v-model="datepickr"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                  @input="setTime()"
                />
              </b-form-group>
            </b-col>
            <b-col md="12" class="mt-1">
              <b-form-group
                label="Select Status"
                invalid-feedback="status is required."
                ref="status"
              >
                <v-select
                  ref="status"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :clearable="false"
                  v-model="attendance.obj.status"
                  :options="statusOptions"
                  :reduce="(opt) => opt.value"
                  label="name"
                  placeholder="select status"
                />
              </b-form-group>
            </b-col>
            <b-col class="mt-1" md="12">
              <b-button
                variant="success"
                class="mr-1 fullWidth"
                @click="saveAttendance()"
                :disabled="request"
                block
              >
                <b-spinner v-if="request" small type="grow" />
                <span v-if="request == false"> Save </span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-sidebar>

      <b-col>
        <div class="d-flex justify-content-between">
          <b-button
            variant="outline-secondary"
            class="mr-50"
            @click="showreport = false"
          >
            <feather-icon class="" icon="ArrowLeftIcon" />
            Back
          </b-button>
          <!-- <div>
            <b-button
              class="mr-50"
              v-for="t in types"
              :key="type"
              :variant="t.value == report.type ? 'primary' : 'outline-primary'"
              @click="setType(t.value)"
            >
              {{ t.name }}
            </b-button>
          </div> -->
        </div>
        <b-card class="mt-1">
          <b-row style="align-items: center">
            <!-- <b-col md="2">
              <b-form-group
                label="Select type"
                invalid-feedback="type is required."
                ref="type"
              >
                <v-select
                  ref="type"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :clearable="false"
                  v-model="report.type"
                  :options="types"
                  :reduce="(opt) => opt.value"
                  label="name"
                  @input="setType()"
                  placeholder="select type"
                />
              </b-form-group>
            </b-col> -->
            <b-col md="2" v-if="showClasses">
              <b-form-group
                label="Select Class"
                :invalid-feedback="$t('Class is required')"
                ref="class"
              >
                <v-select
                  ref="class"
                  multiple
                  :closeOnSelect="false"
                  v-model="classID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="classesOptions"
                  :clearable="false"
                  label="name"
                  :reduce="(val) => val.id"
                  @input="FillSections()"
                  placeholder="Select class"
                />
              </b-form-group>
            </b-col>
            <b-col md="2" v-if="showClasses">
              <b-form-group
                label="Select Section"
                invalid-feedback="Section is required"
                ref="section"
              >
                <v-select
                  multiple
                  :closeOnSelect="false"
                  v-model="secID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="admittedSections"
                  :reduce="(val) => val.id"
                  :clearable="false"
                  @input="checkSections()"
                  ref="section"
                  label="section"
                  placeholder="Select section"
                />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group
                label="Date"
                invalid-feedback=" date is required."
                ref="date"
              >
                <flat-pickr
                  ref="date"
                  :config="config"
                  v-model="report.dtFrom"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
                <!-- @input="setDate()" -->
              </b-form-group>
            </b-col>
            <b-button
              class="ml-1"
              :disabled="gridLoading"
              variant="primary"
              @click="loadgrid()"
            >
              Show
            </b-button>
            <b-button
              variant="success"
              class="ml-1"
              :disabled="saving"
              @click="save()"
            >
              Save
            </b-button>
            <b-dropdown
              variant="success"
              class="ml-1"
              :disabled="saving || marking"
            >
              <template #button-content>
                Mark Status
              </template>
              <b-dropdown-item @click="openMarkStatus('holiday')">
                Holiday
              </b-dropdown-item>
              <b-dropdown-item @click="openMarkStatus('off')">
                Off
              </b-dropdown-item>
              <b-dropdown-item @click="openMarkStatus('EXL')">
                Exam Leave (EXL)
              </b-dropdown-item>
              <b-dropdown-item @click="openMarkStatus('STL')">
                Study Leave (STL)
              </b-dropdown-item>
            </b-dropdown>
            <!-- Send Notification Button -->
            <b-button
              class="ml-1 btn-icon"
              variant="outline-primary"
              v-b-tooltip.hover.top
              title="Send Notification"
              @click="checkPrint('notification')"
              :disabled="iNotification"
            >
              <b-spinner v-if="iNotification" small type="grow" />
              <feather-icon v-if="!iNotification" icon="BellIcon" />
            </b-button>
            <b-button
              variant="outline-danger"
              class="ml-1 btn-icon"
              v-b-tooltip.hover.top
              :title="$t('Delete')"
              @click="DeleteAtt()"
              :disabled="deleting"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>

            <!-- <b-button
              class="ml-1 btn-icon"
              variant="outline-info"
              v-b-tooltip.hover.top
              title="Update"
              @click="openUpdate()"
            >
              <feather-icon icon="EditIcon" />
            </b-button>  -->
            <b-button
              class="ml-1 btn-icon"
              variant="outline-primary"
              v-b-tooltip.hover.top
              title="Smart Attendance"
              @click="showSmart()"
            >
              <feather-icon icon="CheckCircleIcon" />
            </b-button>
            <b-button
              class="ml-1 btn-icon"
              variant="outline-primary"
              v-b-tooltip.hover.top
              title="Reports"
              @click="openReport()"
            >
              <feather-icon icon="BarChart2Icon" />
            </b-button>
            <b-button
              class="ml-1 btn-icon"
              variant="outline-primary"
              v-b-tooltip.hover.top
              title="Messages"
              @click="openMessage()"
            >
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button
              v-if="showDaysSettings"
              class="ml-1 btn-icon"
              variant="outline-primary"
              v-b-tooltip.hover.top
              title="Days Settings"
              @click="openDaysSettings()"
            >
              <feather-icon icon="CalendarIcon" />
            </b-button>
            <b-button
              class="ml-1 btn-icon"
              variant="outline-secondary"
              v-b-tooltip.hover.top
              title="Settings"
              @click="openSett()"
            >
              <feather-icon icon="SettingsIcon" />
            </b-button>
          </b-row>
          <b-row class="mt-1" v-if="showGrid">
            <b-col lg="10" md="9">
              <b-form-group label="Search">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block"
                  placeholder="Search by name or gr"
                />
              </b-form-group>
            </b-col>
            <b-col lg="2" md="3">
              <b-form-group label="Sort By">
                <v-select
                  v-model="sortBy"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="sortOptions"
                  :reduce="(val) => val.value"
                  label="text"
                  @input="sortData()"
                  :clearable="false"
                  placeholder="Select"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-table
                class="mt-1"
                :busy="gridLoading"
                show-empty
                :items="filteredAtt"
                :fields="attGridFields"
                responsive
                hover
                small
              >
                <template #table-busy>
                  <div
                    class="d-flex justify-content-center mb-3"
                    style="margin-top: 50px"
                  >
                    <b-spinner
                      style="width: 3rem; height: 3rem"
                      type="grow"
                      variant="primary"
                      label="Spinning"
                    ></b-spinner>
                  </div>
                </template>

                <template #cell(index)="data">
                  {{ gridData.indexOf(data.item) + 1 }}
                </template>

                <template #cell(cls)="data">
                  <b-badge variant="light-primary">
                    {{ data.item.cls }}
                  </b-badge>
                </template>

                <template #cell(timein)="data">
                  <b-badge
                    variant="light-primary"
                    v-if="data.item.obj.timeIn"
                    @click.stop="
                      (rights.add || rights.edit) &&
                        (data.item.obj.timeIn = null)
                    "
                  >
                    {{
                      new Intl.DateTimeFormat("en-US", {
                        hour: "numeric",
                        minute: "numeric",
                      }).format(new Date(data.item.obj.timeIn))
                    }}
                  </b-badge>
                  <b-form-group
                    v-else-if="rights.add || rights.edit"
                    class="mb-0"
                  >
                    <b-input-group class="set-timepicker">
                      <flat-pickr
                        :config="{
                          enableTime: true,
                          noCalendar: true,
                          altFormat: 'h:i K',
                          altInput: true,
                          dateFormat: 'Y-m-d\\TH:i:S',
                          defaultHour: 8,
                        }"
                        v-model="filteredAtt[data.index].inputTimein"
                        class="form-control"
                      />
                      <b-input-group-append
                        is-text
                        @click.stop="filteredAtt[data.index].inputTimein = null"
                        v-b-tooltip.hover.top
                        title="Clear"
                      >
                        <feather-icon
                          class="cursor-pointer"
                          size="16"
                          icon="XIcon"
                        />
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </template>
                <template #cell(timeout)="data">
                  <b-badge
                    variant="light-primary"
                    v-if="data.item.obj.timeOut"
                    @click.stop="
                      (rights.add || rights.edit) &&
                        (data.item.obj.timeOut = null)
                    "
                  >
                    {{
                      new Intl.DateTimeFormat("en-US", {
                        hour: "numeric",
                        minute: "numeric",
                      }).format(new Date(data.item.obj.timeOut))
                    }}
                  </b-badge>
                  <b-form-group
                    v-else-if="rights.add || rights.edit"
                    class="mb-0"
                  >
                    <b-input-group class="set-timepicker">
                      <flat-pickr
                        :config="{
                          enableTime: true,
                          noCalendar: true,
                          altFormat: 'h:i K',
                          altInput: true,
                          dateFormat: 'Y-m-d\\TH:i:S',
                          defaultHour: 12,
                        }"
                        v-model="filteredAtt[data.index].inputTimeout"
                        class="form-control"
                      />
                      <b-input-group-append
                        is-text
                        @click.stop="
                          filteredAtt[data.index].inputTimeout = null;
                          testCheck(data.index);
                        "
                        v-b-tooltip.hover.top
                        title="Clear"
                      >
                        <feather-icon
                          class="cursor-pointer"
                          size="16"
                          icon="XIcon"
                        />
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </template>

                <template #cell(status)="data">
                  <div class="d-flex align-items-center">
                    <b-button
                      pill
                      size="sm"
                      style="margin-inline: 2px"
                      :variant="
                        data.item.obj.status == 'P'
                          ? 'success'
                          : 'outline-success'
                      "
                      @click="changeAtt(data.index, 'P')"
                    >
                      P
                    </b-button>
                    <b-button
                      pill
                      size="sm"
                      style="margin-inline: 2px"
                      :variant="
                        data.item.obj.status == 'A'
                          ? 'danger'
                          : 'outline-danger'
                      "
                      @click="changeAtt(data.index, 'A')"
                    >
                      A
                    </b-button>
                    <b-button
                      pill
                      size="sm"
                      style="margin-inline: 2px"
                      :variant="
                        data.item.obj.status == 'L' ? 'info' : 'outline-info'
                      "
                      @click="changeAtt(data.index, 'L')"
                    >
                      L
                    </b-button>
                    <b-button
                      pill
                      size="sm"
                      style="margin-inline: 2px"
                      :variant="
                        data.item.obj.status.toLowerCase() == 'late'
                          ? 'warning'
                          : 'outline-warning'
                      "
                      @click="changeAtt(data.index, 'Late')"
                    >
                      Late
                    </b-button>
                    <b-button
                      pill
                      size="sm"
                      style="margin-inline: 2px"
                      :variant="
                        data.item.obj.status == 'H' ? 'info' : 'outline-info'
                      "
                      @click="changeAtt(data.index, 'H')"
                    >
                      H
                    </b-button>
                    <b-button
                      pill
                      size="sm"
                      style="margin-inline: 2px"
                      :variant="
                        data.item.obj.status == 'Off'
                          ? 'secondary'
                          : 'outline-secondary'
                      "
                      @click="changeAtt(data.index, 'Off')"
                    >
                      Off
                    </b-button>
                    <b-button
                      pill
                      size="sm"
                      style="margin-inline: 2px"
                      v-b-tooltip.hover.top
                      title="Exam Leave"
                      :variant="
                        data.item.obj.status == 'EXL'
                          ? 'dark'
                          : 'outline-dark'
                      "
                      @click="changeAtt(data.index, 'EXL')"
                    >
                      EXL
                    </b-button>
                    <b-button
                      pill
                      size="sm"
                      style="margin-inline: 2px"
                      v-b-tooltip.hover.top
                      title="Study Leave"
                      :variant="
                        data.item.obj.status == 'STL'
                          ? 'primary'
                          : 'outline-primary'
                      "
                      @click="changeAtt(data.index, 'STL')"
                    >
                      STL
                    </b-button>
                    <b-button
                      v-if="timeObj && timeObj.valueBool"
                      pill
                      size="sm"
                      style="margin-inline: 2px"
                      :variant="
                        data.item.obj.status == 'ED'
                          ? 'danger'
                          : 'outline-danger'
                      "
                      @click="changeAtt(data.index, 'ED')"
                    >
                      ED
                    </b-button>
                    <b-button
                      v-if="timeObj && timeObj.valueBool"
                      pill
                      size="sm"
                      style="margin-inline: 2px"
                      class="text-nowrap"
                      :variant="
                        data.item.obj.status == 'Late + ED'
                          ? 'primary'
                          : 'outline-primary'
                      "
                      @click="changeAtt(data.index, 'Late + ED')"
                    >
                      Late + ED
                    </b-button>
                  </div>
                </template>

                <template #cell(remarks)="data">
                  <b-form-textarea
                    style="width: 200px"
                    rows="2"
                    size="sm"
                    v-model.trim="data.item.obj.meta_notes"
                    placeholder="Enter remarks"
                  />
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <!-- attendance card -->
    <b-row align-h="center" v-else-if="dataLoading">
      <b-spinner
        class="m-5"
        style="width: 4rem; height: 4rem"
        type="grow"
        variant="primary"
        label="Spinning"
      ></b-spinner>
    </b-row>
    <div v-else>
      <b-sidebar
        id="sidebar-right"
        ref="mySidebar"
        bg-variant="white"
        v-model="visibility"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">Settings</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hideSideBar()"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row class="pt-1 pb-1">
            <b-col
              class="d-flex align-items-center justify-content-between mb-1"
              md="12"
            >
              <h4 class="mr-1">Barcode</h4>
              <b-form-checkbox
                v-model="settings.attendanceMode"
                switch
                value="barcode"
                unchecked-value=""
              />
            </b-col>
            <b-col
              class="d-flex align-items-center justify-content-between mb-1"
              md="12"
            >
              <h4 class="mr-1">Notification on arrival</h4>
              <b-form-checkbox v-model="settings.notifyArrival" switch />
            </b-col>
            <b-col
              class="d-flex align-items-center justify-content-between mb-1"
              md="12"
            >
              <h4 class="mr-1">Notification on departure</h4>
              <b-form-checkbox v-model="settings.notifyDeparture" switch />
            </b-col>
            <b-col
              class="d-flex align-items-center justify-content-between mb-1"
              md="12"
            >
              <h4 class="mr-1">App Notification arrival</h4>
              <b-form-checkbox
                v-model="settings.appNotificationArrival"
                switch
              />
            </b-col>
            <b-col
              class="d-flex align-items-center justify-content-between mb-1"
              md="12"
            >
              <h4 class="mr-1">App Notification departure</h4>
              <b-form-checkbox
                v-model="settings.appNotificationDeparture"
                switch
              />
            </b-col>
            <b-col
              class="d-flex align-items-center justify-content-between mb-1"
              md="12"
            >
              <h4 class="mr-1">Show dues</h4>
              <b-form-checkbox v-model="settings.showDues" switch />
            </b-col>
            <b-col
              class="d-flex align-items-center justify-content-between mb-1"
              md="12"
            >
              <h4 class="mr-1">Show recent attendance</h4>
              <b-form-checkbox v-model="settings.showRecent" switch />
            </b-col>
            <b-col
              class="d-flex align-items-center justify-content-between mb-1"
              md="12"
            >
              <h4 class="mr-1">Auto hide</h4>
              <b-form-checkbox v-model="settings.autoHide" switch />
            </b-col>
            <b-col v-if="settings.autoHide" md="12">
              <h4 class="mr-1">
                Hide After <span style="font-size: 14px">(seconds)</span>
              </h4>
              <b-form-input
                id="mc-first-name"
                type="number"
                placeholder=""
                ref="autosec"
                v-model="settings.hideAfterSeconds"
              />
            </b-col>
            <b-col class="mt-1" md="12">
              <b-button
                variant="success"
                class="mr-1 fullWidth"
                @click="saveSettings()"
                :disabled="request"
                block
              >
                <b-spinner v-if="request" small type="grow" />
                <span v-if="request == false"> Save </span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-sidebar>

      <b-row align-h="center">
        <b-col v-if="studentLoading" md="4">
          <b-card class="text-center p-1" style="position: relative">
            <b-spinner
              class="m-5"
              style="width: 4rem; height: 4rem"
              variant="primary"
              label="Spinning"
            ></b-spinner>
          </b-card>
        </b-col>
        <b-col lg="4" md="5" v-else>
          <b-card
            class="text-center p-1"
            style="position: relative"
            :class="{
              'set-border': checkTime
                ? currentStd.isEarly ||
                  currentStd.dues > 0 ||
                  (currentStaff && currentStaff.isEarly)
                : currentStd.dues > 0,
              'set-border-late': currentStaff
                ? currentStaff.isLate
                : currentStd.isLate,
            }"
          >
            <div
              style="position: absolute; right: 15px; top: 15px; display: none"
            >
              <!-- style="position: absolute; right: 15px; top: 15px" -->
              <feather-icon
                class="cursor-pointer"
                icon="SettingsIcon"
                size="22"
                v-b-tooltip.hover.right
                title="Settings"
                @click="showSettings()"
              />
              <br />
              <template v-if="syncObj && syncObj.valueBool">
                <b-spinner
                  v-if="syncing"
                  class="mt-2"
                  variant="primary"
                  label="Spinning"
                  style="width: 22px; height: 22px"
                ></b-spinner>
                <feather-icon
                  v-else
                  class="cursor-pointer mt-2"
                  icon="RefreshCcwIcon"
                  size="22"
                  v-b-tooltip.hover.right
                  title="Sync Attendance"
                  :badge="syncData.length"
                  @click="syncAtt()"
                />
              </template>
            </div>
            <template v-if="currentStaff">
              <b-img
                v-if="currentStaff.staff.picture"
                class="round mb-1"
                :src="currentStaff.staff.picture"
                style="
                  width: 100px;
                  height: 100px;
                  object-fit: cover;
                  border-radius: 50%;
                "
                :class="{ 'set-picSize': picObj && picObj.valueBool }"
              />
              <b-img
                v-else
                class="round mb-1"
                src="https://cdn.cloudious.net/file-1677912450367-333289208.png"
                style="
                  width: 100px;
                  height: 100px;
                  object-fit: cover;
                  border-radius: 50%;
                "
                :class="{ 'set-picSize': picObj && picObj.valueBool }"
              />
              <h3 v-if="currentStaff.staff.name" class="mb-1">
                {{ currentStaff.staff.name }}
              </h3>
              <h4 v-if="currentStaff.designation">
                {{ currentStaff.staff.designation }}
              </h4>
              <h4 v-else>-</h4>
              <h1 v-if="currentStaff.time" class="mt-1">
                {{
                  new Intl.DateTimeFormat("en-US", {
                    hour: "numeric",
                    minute: "numeric",
                  }).format(new Date(currentStaff.time))
                }}
              </h1>
              <b-badge v-if="currentStaff.isEarly" variant="danger">
                Early Departure
              </b-badge>
              <b-badge v-else-if="currentStaff.isLate" variant="warning">
                Late
              </b-badge>
              <br />
              <b-badge
                v-if="
                  (currentStaff.isEarly || currentStaff.isLate) &&
                  currentStaff.delay
                "
                :variant="currentStaff.isEarly ? 'danger' : 'warning'"
                class="mt-25"
              >
                {{ currentStaff.delay }}
              </b-badge>
            </template>

            <template v-else>
              <b-img
                v-if="
                  currentStd.std.picture == '' || currentStd.std.picture == null
                "
                class="round mb-1"
                src="https://cdn.cloudious.net/file-1677912450367-333289208.png"
                style="
                  width: 100px;
                  height: 100px;
                  object-fit: cover;
                  border-radius: 50%;
                "
                :class="{
                  'set-picSize': picObj && picObj.valueBool,
                  'set-border': currentStd.dues > 0,
                }"
              />
              <b-img
                v-else
                class="round mb-1"
                :src="currentStd.std.picture"
                style="
                  width: 100px;
                  height: 100px;
                  object-fit: cover;
                  border-radius: 50%;
                "
                :class="{
                  'set-picSize': picObj && picObj.valueBool,
                  'set-border': currentStd.dues > 0,
                }"
              />
              <h3 v-if="currentStd.std.name" class="mb-1">
                {{ currentStd.std.name }}
              </h3>
              <h3 v-else class="mb-1">-</h3>
              <h4 v-if="currentStd.std.cls" style="margin-bottom: 0.5rem">
                {{ currentStd.std.cls }}
              </h4>
              <h4 v-else style="margin-bottom: 0.5rem">-</h4>
              <h4 style="font-weight: 400; margin-bottom: 0.5rem">
                GR #
                <span v-if="currentStd.std.grNo">{{
                  currentStd.std.grNo
                }}</span>
                <span v-else>-</span>
              </h4>
              <h4
                v-if="settings.showDues"
                style="font-weight: 400; margin-bottom: 0.5rem"
              >
                Dues: <span v-if="currentStd.dues">{{ currentStd.dues }}</span>
                <span v-else>-</span>
              </h4>
              <h1 v-if="currentStd.time" class="mt-1">
                {{
                  new Intl.DateTimeFormat("en-US", {
                    hour: "numeric",
                    minute: "numeric",
                  }).format(new Date(currentStd.time))
                }}
              </h1>
              <b-badge v-if="currentStd.isEarly" variant="danger">
                Early Departure
              </b-badge>
              <b-badge v-else-if="currentStd.isLate" variant="warning">
                Late
              </b-badge>
              <br />
              <b-badge
                v-if="
                  (currentStd.isEarly || currentStd.isLate) && currentStd.delay
                "
                :variant="currentStd.isEarly ? 'danger' : 'warning'"
                class="mt-25"
              >
                {{ currentStd.delay }}
              </b-badge>
            </template>

            <!-- <h4 class="text-danger font-weight-bolder">dues</h4> -->
            <b-row align-h="center">
              <b-form-input
                class="mt-1"
                style="width: 80%"
                id="mc-first-name"
                placeholder="Scan here"
                ref="name"
                autofocus
                v-model="studentID"
                @keyup.enter="GetStudent()"
              />
            </b-row>
          </b-card>
        </b-col>
        <b-col lg="1" md="2" class="d-flex flex-wrap d-md-block">
          <b-card
            class="mb-1 mr-1 mr-md-0 rounded-circle"
            style="width: 45px; height: 45px"
            v-b-tooltip.hover.right="'Settings'"
            body-class="d-flex align-items-center justify-content-center p-50"
          >
            <feather-icon
              class="cursor-pointer"
              icon="SettingsIcon"
              size="22"
              @click="showSettings()"
            />
          </b-card>
          <b-card
            v-if="syncObj && syncObj.valueBool"
            class="mb-1 mr-1 mr-md-0 rounded-circle"
            style="width: 45px; height: 45px"
            v-b-tooltip.hover.right="'Sync Attendance'"
            body-class="d-flex align-items-center justify-content-center p-50"
          >
            <b-spinner
              v-if="syncing"
              class=""
              variant="primary"
              label="Spinning"
              style="width: 22px; height: 22px"
            ></b-spinner>
            <feather-icon
              v-else
              class="cursor-pointer"
              icon="RefreshCcwIcon"
              size="22"
              :badge="syncData.length + staffData.length"
              @click="syncAtt()"
            />
          </b-card>
          <!-- <b-card
            v-if="syncObj && syncObj.valueBool"
            class="mb-1 mr-1 mr-md-0 rounded-circle"
            style="width: 45px; height: 45px"
            v-b-tooltip.hover.right="'Student In'"
            body-class="d-flex align-items-center justify-content-center p-50"
          >
            <feather-icon
              class="cursor-pointer"
              icon="UserPlusIcon"
              size="22"
              :badge="stdInCount"
            />
          </b-card> -->
          <b-card
            class="mb-1 mr-1 mr-md-0 rounded-circle"
            style="width: 45px; height: 45px"
            v-b-tooltip.hover.right="'Smart Attendance'"
            body-class="d-flex align-items-center justify-content-center p-50"
          >
            <feather-icon
              class="cursor-pointer"
              icon="CheckCircleIcon"
              size="22"
              @click="showSmart()"
            />
          </b-card>
          <b-card
            class="mb-1 mr-1 mr-md-0 rounded-circle"
            style="width: 45px; height: 45px"
            v-b-tooltip.hover.right="'Reports'"
            body-class="d-flex align-items-center justify-content-center p-50"
          >
            <feather-icon
              class="cursor-pointer"
              icon="BarChart2Icon"
              size="22"
              @click="openReport()"
            />
          </b-card>
          <b-card
            class="mb-1 mr-1 mr-md-0 rounded-circle"
            style="width: 45px; height: 45px"
            v-b-tooltip.hover.right="'Messages'"
            body-class="d-flex align-items-center justify-content-center p-50"
          >
            <feather-icon
              class="cursor-pointer"
              icon="MailIcon"
              size="22"
              @click="openMessage()"
            />
          </b-card>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col lg="4" md="5">
          <b-button variant="primary" block @click="openDetails()">
            Show Details
          </b-button>
        </b-col>
        <b-col lg="1" md="2"></b-col>
      </b-row>
      <b-row v-if="this.settings.showRecent && this.filteredItems.length > 0">
        <b-col md="12">
          <h3>Recent Attendance</h3>
        </b-col>
        <b-col lg="3" md="4" v-for="card in filteredItems" :key="card">
          <b-card
            class="text-center shadow-sm"
            style="border-radius: 12px; overflow: hidden"
            :class="{
              'set-border': checkTime
                ? card.isEarly || card.dues > 0
                : card.dues > 0,
              'set-border-late': card.isLate,
            }"
          >
            <template v-if="card.isStaff">
              <b-avatar
                v-if="card.staff.picture == '' || card.staff.picture == null"
                size="80"
                src="https://cdn.cloudious.net/file-1677912450367-333289208.png"
                class="mb-1 mt-1 shadow-sm"
              />
              <b-avatar
                v-else
                size="80"
                :src="card.staff.picture"
                class="mb-1 mt-1 shadow-sm"
              />

              <h4 class="font-weight-bolder mb-50">{{ card.staff.name }}</h4>

              <h6 class="text-muted mb-1">
                {{ card.staff.designation ? card.staff.designation : "-" }}
              </h6>

              <div
                class="d-flex justify-content-center flex-wrap align-items-center mb-1"
                style="gap: 5px"
              >
                <b-badge variant="light-primary" pill>
                  <feather-icon icon="ClockIcon" size="12" class="mr-25" />
                  {{
                    new Intl.DateTimeFormat("en-US", {
                      hour: "numeric",
                      minute: "numeric",
                    }).format(new Date(card.time))
                  }}
                </b-badge>
                <b-badge
                  v-if="card.staff.status"
                  variant="light-success"
                  pill
                  class="text-uppercase"
                  style="letter-spacing: 0.5px"
                >
                  {{ card.staff.status }}
                </b-badge>
              </div>

              <div
                v-if="checkTime"
                class="d-flex justify-content-center flex-wrap align-items-center"
              >
                <b-badge
                  v-if="card.isEarly"
                  variant="danger"
                  class="mr-25 mb-25"
                  >Early Departure</b-badge
                >
                <b-badge
                  v-else-if="card.isLate"
                  variant="warning"
                  class="mr-25 mb-25"
                >
                  Late
                </b-badge>
                <b-badge
                  v-if="(card.isEarly || card.isLate) && card.delay"
                  :variant="card.isEarly ? 'danger' : 'warning'"
                  class="mr-25 mb-25"
                >
                  {{ card.delay }}
                </b-badge>
                <b-badge variant="success" class="mb-25"
                  >Time {{ card.toCheck }}</b-badge
                >
              </div>
            </template>

            <template v-else>
              <b-avatar
                v-if="card.std.picture == '' || card.std.picture == null"
                size="80"
                src="https://cdn.cloudious.net/file-1677912450367-333289208.png"
                class="mb-1 mt-1 shadow-sm"
                :class="{
                  'border-danger': card.dues > 0,
                }"
              />
              <b-avatar
                v-else
                size="80"
                :src="card.std.picture"
                class="mb-1 mt-1 shadow-sm"
                :class="{
                  'border-danger': card.dues > 0,
                }"
              />

              <h4 class="font-weight-bolder mb-50">{{ card.std.name }}</h4>

              <h6 class="text-muted mb-1">
                {{ card.std.cls }}
                <span class="mx-50">•</span>
                GR# {{ card.std.grNo }}
              </h6>

              <div
                class="d-flex justify-content-center flex-wrap align-items-center mb-1"
                style="gap: 5px"
              >
                <b-badge variant="light-primary" pill>
                  <feather-icon icon="ClockIcon" size="12" class="mr-25" />
                  {{
                    new Intl.DateTimeFormat("en-US", {
                      hour: "numeric",
                      minute: "numeric",
                    }).format(new Date(card.time))
                  }}
                </b-badge>
                <b-badge
                  v-if="card.std.status"
                  :variant="
                    card.std.status.toLowerCase() == 'absent'
                      ? 'light-danger'
                      : 'light-success'
                  "
                  pill
                  class="text-uppercase"
                  style="letter-spacing: 0.5px"
                >
                  {{ card.std.status }}
                </b-badge>
                <b-badge
                  v-if="settings.showDues && card.dues > 0"
                  variant="light-danger"
                  pill
                >
                  Dues: {{ card.dues }}
                </b-badge>
              </div>

              <div
                v-if="checkTime"
                class="d-flex justify-content-center flex-wrap align-items-center"
              >
                <b-badge
                  v-if="card.isEarly"
                  variant="danger"
                  class="mr-25 mb-25"
                  >Early Departure</b-badge
                >
                <b-badge
                  v-else-if="card.isLate"
                  variant="warning"
                  class="mr-25 mb-25"
                >
                  Late
                </b-badge>
                <b-badge
                  v-if="(card.isEarly || card.isLate) && card.delay"
                  :variant="card.isEarly ? 'danger' : 'warning'"
                  class="mr-25 mb-25"
                >
                  {{ card.delay }}
                </b-badge>
                <b-badge variant="success" class="mb-25"
                  >Time {{ card.toCheck }}</b-badge
                >
              </div>
            </template>
            <!-- variant="transparent" -->
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { required, minLength, between } from "vuelidate/lib/validators";
import {
  BCard,
  BRow,
  BAvatar,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  VBTooltip,
  BFormCheckbox,
  BModal,
  BFormGroup,
  BForm,
  BMediaAside,
  BAside,
  BSpinner,
  BCardTitle,
  BCardText,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BInputGroupAppend,
  BInputGroup,
  BFormTextarea,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapActions, mapGetters } from "vuex";

import axios from "axios";

export default {
  components: {
    //Multiselect,
    BFormTextarea,
    BCard,
    BRow,
    BImg,
    BAvatar,
    BBadge,
    BTable,
    BCol,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BModal,
    BForm,
    BPagination,
    BSpinner,
    BDropdown,
    BDropdownItem,
    vSelect,
    flatPickr,
  },
  props: {},
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  async created() {
    if (!this.$store.state.rights[this.$route.name]) {
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];
      this.LoadClasses();
      this.LoadSettings();
      this.loadSessions();
      this.loadOther();
      this.LoadDepartments();
      this.loadOtherAll();
      if (this.syncObj && this.syncObj.valueBool) {
        this.loadAll();
        this.loadAllStaff();
        // this.$store.commit("setSyncList", []);
        // this.$store.commit("setStaffSyncList", []);
        // this.syncData = [];
        // this.staffData = [];
      } else {
        this.$store.commit("setSyncList", []);
        this.$store.commit("setStaffSyncList", []);
        this.syncData = [];
        this.staffData = [];
      }
    }
  },
  beforeDestroy() {
    if (this.intervalId) clearInterval(this.intervalId);
    this.isLoopRunning = false;
  },
  computed: {
    // stdInCount() {
    //   return this.allStudents.filter((el) => el.toCheck == "out").length;
    // },
    // stdOutCount() {
    //   return this.allStudents.filter(el => el.toCheck == 'in').length
    // },
    filteredItems: function () {
      return this.items.slice(0, 12);
    },
    filteredAtt() {
      return this.gridData.filter((pro) => {
        return (
          pro.name.toLowerCase().match(this.searchQuery.toLowerCase()) ||
          pro.grNo.toLowerCase().match(this.searchQuery.toLowerCase())
        );
      });
    },
    attGridFields() {
      if (["myskooliota", "myskooliota2"].includes(this.reportDomain)) {
        return [...this.fields, { label: "remarks", key: "remarks" }];
      }
      return this.fields;
    },
    showDaysSettings() {
      const s = this.daySettingObj;
      if (!s) return false;
      if (s.valueBool === true || s.valueBool === 1) return true;
      if (typeof s.valueBool === "string") {
        const t = s.valueBool.toLowerCase().trim();
        return t === "true" || t === "1";
      }
      return false;
    },
    studentHolidayHistoryRange() {
      const total = this.studentHolidayHistoryTotal || 0;
      if (!total) return { start: 0, end: 0 };
      const start =
        (this.studentHolidayHistoryPage - 1) *
          this.studentHolidayHistoryPageSize +
        1;
      const end = Math.min(
        this.studentHolidayHistoryPage * this.studentHolidayHistoryPageSize,
        total
      );
      return { start, end };
    },
    studentHolidayHistoryStatusFilterOptions() {
      const base = [{ label: "All types", value: "" }];
      const fromApi = this.studentHolidayHistoryStatusOptions || [];
      if (fromApi.length) return base.concat(fromApi);
      return base.concat(this.defaultStudentHolidayHistoryStatusOptions);
    },
    showStudentHolidayHistoryCampusColumn() {
      return Number(this.getStudentHolidayHistoryCampusId()) === 0;
    },
    visibleStudentHolidayHistoryFields() {
      const fields = this.studentHolidayHistoryFields || [];
      if (this.showStudentHolidayHistoryCampusColumn) return fields;
      return fields.filter((f) => f.key !== "campusName");
    },
    holidaySummaryHasWarn() {
      return (Number(this.holidaySummary?.alreadyHoliday) || 0) > 0;
    },
    holidaySummaryTotalProcessed() {
      const s = this.holidaySummary || {};
      if (s.totalProcessed != null && s.totalProcessed !== "") {
        return s.totalProcessed;
      }
      return (
        (Number(s.created) || 0) +
        (Number(s.updated) || 0) +
        (Number(s.alreadyHoliday) || 0)
      );
    },
  },
  data() {
    return {
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      rights: {},
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        // mode: "range",
      },
      repDate: "",
      config2: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        mode: "range",
      },
      departments: [],
      request: false,
      sheetLoading: false,
      exporting: false,
      attendance: {
        picture: null,
        obj: {
          status: null,
        },
      },
      colorDep: [],
      visibility1: false,

      sidebarTitle: "Add Balance",
      sidebarButton: "Save",
      buttonIcon: "PlusIcon",
      dataLoading: false,
      studentLoading: false,
      visibility: false,
      visibility2: false,
      visibility3: false,
      visibility4: false,
      visibility5: false,
      logoloading: "",
      searchQuery: "",
      sortOptions: [
        { text: "Name", value: "name" },
        { text: "GR#", value: "gr" },
      ],
      sortBy: this.$store.state.attSort,
      currentPage: 1,
      totalCount: 0,
      perPage: 30,

      report: {
        type: "",
        dtFrom: new Date().toJSON().split("T")[0],
        // dtTo: null,
        clsIDs: [],
        secIDs: [],
      },
      editAtt: false,
      timePicker: "",
      datepickr: "",
      showreport: false,
      rangeDate: null,
      types: [
        { name: "Student", value: "student" },
        { name: "Staff", value: "staff" },
      ],
      statusOptions: [
        { name: "All", value: "" },
        { name: "Present", value: "P" },
        { name: "Absent", value: "A" },
        { name: "Leave", value: "L" },
        { name: "Late", value: "Late" },
        { name: "Holiday", value: "H" },
        { name: "Off", value: "Off" },
        { name: "Early Departure", value: "ED" },
        { name: "Late + Early Departure", value: "Late + ED" },
      ],
      smartOptions: [
        { name: "Absent", value: "A" },
        { name: "Leave", value: "L" },
        { name: "Late", value: "Late" },
      ],
      showClasses: false,
      classes: [],
      classesOptions: [{ name: "All Classes", id: 0 }],
      admittedSections: [{ section: "All Sections", id: 0 }],

      classID: [0],
      secID: [0],

      gridData: [],
      showGrid: false,
      gridLoading: false,
      fields: [
        { label: "S.no", key: "index" },
        { label: "gr no", key: "grNo" },
        { label: "name", key: "name" },
        { label: "Father name", key: "father_name" },
        { label: "class", key: "cls" },
        { label: "status", key: "status" },
        // { key: "actions", label: "actions" },
      ],

      errors: {
        status: false,
      },

      index: null,
      items: [],
      accountOptions: [
        // {
        //   id: 1,
        //   code: 999,
        // },
      ],

      secText: "Section",
      classText: "Class",
      selected: null,
      myObj: {
        picture: null,
        cls: null,
        grNo: null,
        name: null,
      },
      currentStd: {
        std: {
          picture: null,
          cls: null,
          grNo: null,
          name: null,
        },
      },
      settings: {
        id: 0,
        campusID: this.$store.state.userData.cId,
        notifyArrival: false,
        notifyDeparture: false,
        appNotificationArrival: false,
        appNotificationDeparture: false,
        showDues: false,
        showRecent: false,
        autoHide: false,
        hideAfterSeconds: 5,
        attendanceMode: "",
      },
      msgObj: {
        dt: "",
        clsIDs: [0],
        secIDs: [0],
        status: "A",
      },
      msgSecOptions: [{ section: "All Sections", id: 0 }],
      msgClass: [0],
      msgSection: [0],

      showNotificationModal: false,
      notificationStatus: "A",

      repObj: {
        type: "",
        dtFrom: "",
        clsIDs: [0],
        secIDs: [0],
        status: [],
      },
      repSecOptions: [{ section: "All Sections", id: 0 }],
      repClass: [0],
      repSection: [0],

      detailObj: {},
      timeout: 10000,
      studentID: null,
      saving: false,
      deleting: false,
      iNotification: false,

      smartObj: {
        status: "",
        dt: null,
        dtFrom: null,
        dtTo: null,
        gr: "",
      },
      sessions: [],
      sessionID: 0,
      picObj: null,
      syncObj: {
        valueBool: true,
      },
      allStudents: [],
      syncing: false,
      syncData: this.$store.state.syncList,
      intervalId: null,
      allStaff: [],
      staffData: this.$store.state.staffSyncList,
      currentStaff: null,
      // {
      //   id: 0,
      //   name: "",
      //   picture: null,
      //   designation: "",
      // },
      checkInObj: null,
      checkOutObj: null,
      savingCh: false,
      timeObj: null,
      checkTime: false,
      hideDuesAlert: null,
      daySettingObj: null,
      unMObj: null,
      holiObj: {
        dtFrom: "",
        dtTo: "",
        departmentIDs: [0],
        clsIDs: [0],
        secIDs: [0],
        statusType: "holiday",
        reason: "",
      },
      markStatusOptions: [
        { label: "Holiday", value: "holiday" },
        { label: "Off", value: "off" },
        { label: "Exam Leave (EXL)", value: "EXL" },
        { label: "Study Leave (STL)", value: "STL" },
      ],
      holiSecOptions: [{ section: "All Sections", id: 0 }],
      visibility6: false,
      marking: false,
      settingAttendance: false,
      holidaySummaryVisible: false,
      holidaySummary: null,
      studentHolidayHistoryVisible: false,
      studentHolidayHistoryLoading: false,
      studentHolidayHistoryDeletingId: null,
      studentHolidayHistoryItems: [],
      studentHolidayHistoryPage: 1,
      studentHolidayHistoryPageSize: 50,
      studentHolidayHistoryTotal: 0,
      studentHolidayHistoryFilters: {
        dtFrom: "",
        dtTo: "",
        status: "",
      },
      studentHolidayHistoryStatusOptions: [],
      defaultStudentHolidayHistoryStatusOptions: [
        { label: "Holiday (H)", value: "H" },
        { label: "Exam Leave (EXL)", value: "EXL" },
        { label: "Study Leave (STL)", value: "STL" },
        { label: "Off", value: "Off" },
      ],
      studentHolidayHistoryFields: [
        { key: "campusName", label: "Campus", thClass: "hh-th", tdClass: "hh-td" },
        { key: "status", label: "Status", thClass: "hh-th", tdClass: "hh-td" },
        { key: "dtFrom", label: "From", thClass: "hh-th", tdClass: "hh-td" },
        { key: "dtTo", label: "To", thClass: "hh-th", tdClass: "hh-td" },
        { key: "reason", label: "Reason", thClass: "hh-th", tdClass: "hh-td" },
        { key: "clsIDs", label: "Classes", thClass: "hh-th", tdClass: "hh-td" },
        { key: "secIDs", label: "Sections", thClass: "hh-th", tdClass: "hh-td" },
        {
          key: "createdByName",
          label: "Created By",
          thClass: "hh-th",
          tdClass: "hh-td",
        },
        {
          key: "createdAt",
          label: "Created At",
          thClass: "hh-th",
          tdClass: "hh-td",
        },
        {
          key: "actions",
          label: "",
          thClass: "hh-th hh-th-actions",
          tdClass: "hh-td hh-td-actions",
        },
      ],
      isLoopRunning: false,
      updateObj: {
        friday: false,
        saturdaySunday: false,
        clsIDs: [0],
        date: "",
        dateSS: "",
      },
      savingUpdate: false,

      // Student Availability / Days Settings
      visibilityDays: false,
      availLoading: false,
      availSaving: false,
      availDeleting: null,
      availStatusUpdating: null,
      availList: [],
      availTotal: 0,
      availPage: 1,
      availPageSize: 10,
      availSecOptions: [{ section: "All Sections", id: 0 }],
      weekdayOptions: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      availObj: {
        id: 0,
        classIDs: [0],
        sectionIDs: [0],
        days: [],
        status: "Off",
      },
    };
  },
  validations: {
    depObj: {
      name: {
        required,
        minLength: minLength(4),
      },
    },
    age: {
      between: between(20, 30),
    },
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    testCheck(ind) {
      console.log(this.filteredAtt[ind].inputTimeout);
    },

    openMarkStatus(statusType = "holiday") {
      this.holiObj = {
        dtFrom: "",
        dtTo: "",
        departmentIDs: [0],
        clsIDs: [0],
        secIDs: [0],
        statusType,
        reason: "",
      };
      this.holiSecOptions = [{ section: "All Sections", id: 0 }];
      this.visibility6 = true;

      const refs = [
        "hol_class",
        "hol_section",
        "hol_dateF",
        "hol_dateT",
        "hol_status",
      ];
      refs.forEach((refName) => {
        const elem = this.$refs[refName];
        if (elem) elem.state = undefined;
      });
    },

    openDaysSettings() {
      this.resetAvailForm();
      this.availPage = 1;
      this.availList = [];
      this.availTotal = 0;
      this.availLoading = true;
      this.visibilityDays = true;
    },

    resetAvailForm() {
      this.availObj = {
        id: 0,
        classIDs: [0],
        sectionIDs: [0],
        days: [],
        status: "Off",
      };
      this.availSecOptions = [{ section: "All Sections", id: 0 }];
    },

    joinAvailIds(ids) {
      if (!Array.isArray(ids) || !ids.length || ids.includes(0)) return "0";
      return ids.filter((id) => id !== 0).join(",");
    },

    parseAvailIds(value) {
      if (value === null || value === undefined || value === "") return [0];
      if (Array.isArray(value)) {
        const nums = value
          .map((v) => Number(v))
          .filter((v) => !Number.isNaN(v));
        return nums.length ? nums : [0];
      }
      const parts = String(value)
        .split(",")
        .map((part) => Number(String(part).trim()))
        .filter((n) => !Number.isNaN(n));
      if (!parts.length || parts.includes(0)) return [0];
      return parts;
    },

    setAvailClass() {
      if (this.availObj.classIDs.at(-1) == 0) {
        this.availObj.classIDs = [0];
        this.availSecOptions = [{ section: "All Sections", id: 0 }];
        this.availObj.sectionIDs = [0];
      } else {
        this.availObj.classIDs = this.availObj.classIDs.filter((el) => el != 0);

        if (this.availObj.classIDs.length == 1) {
          let obj = this.classes.find(
            (el) => el.cls.id == this.availObj.classIDs[0]
          );
          if (obj && obj.sections.length > 0) {
            this.availSecOptions = [...obj.sections];
            this.availSecOptions.unshift({ section: "All Sections", id: 0 });
          } else {
            this.availSecOptions = [{ section: "All Sections", id: 0 }];
          }
          this.availObj.sectionIDs = [0];
        } else {
          this.availSecOptions = [{ section: "All Sections", id: 0 }];
          this.availObj.sectionIDs = [0];
        }
      }
    },

    setAvailSections() {
      if (this.availObj.sectionIDs.at(-1) == 0) {
        this.availObj.sectionIDs = [0];
      } else {
        this.availObj.sectionIDs = this.availObj.sectionIDs.filter(
          (el) => el != 0
        );
      }
    },

    formatAvailClasses(item) {
      const ids = this.parseAvailIds(item.classIDs || item.classIds);
      if (ids.includes(0)) return "All Classes";
      const names = ids
        .map((id) => {
          const fromOptions = (this.classesOptions || []).find(
            (c) => c && c.id == id
          );
          if (fromOptions && fromOptions.name) return fromOptions.name;

          const fromClasses = (this.classes || []).find(
            (c) => c && c.cls && c.cls.id == id
          );
          if (fromClasses && fromClasses.cls && fromClasses.cls.name) {
            return fromClasses.cls.name;
          }

          return `Class #${id}`;
        })
        .filter(Boolean);
      return names.length ? names.join(", ") : "—";
    },

    formatAvailSections(item) {
      const ids = this.parseAvailIds(item.sectionIDs || item.sectionIds);
      if (ids.includes(0)) return "All Sections";

      const names = ids.map((id) => {
        for (const cls of this.classes || []) {
          const sections = (cls && cls.sections) || [];
          const found = sections.find((s) => s && s.id == id);
          if (found) return found.section || found.name || `Section #${id}`;
        }
        return `Section #${id}`;
      });

      return names.join(", ");
    },

    splitAvailDays(days) {
      if (!days) return [];
      return String(days)
        .split(",")
        .map((d) => d.trim())
        .filter(Boolean);
    },

    async loadStudentAvailability() {
      this.availLoading = true;
      try {
        const res = await this.get({
          url:
            this.$store.state.domain +
            "StudentAvailability/GetByPagination?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&pageNumber=" +
            this.availPage +
            "&pageSize=" +
            this.availPageSize,
          token: this.$store.state.userData.token,
          dashboard: true,
        });

        let rows = [];
        let total = 0;
        const payload = res && res.data !== undefined ? res.data : res;

        if (Array.isArray(payload)) {
          rows = payload;
          total = payload.length;
        } else if (payload && Array.isArray(payload.data)) {
          rows = payload.data;
          total = Number(
            payload.count ||
              payload.totalCount ||
              payload.total ||
              (res && (res.count || res.totalCount)) ||
              rows.length
          );
        } else if (payload && Array.isArray(payload.items)) {
          rows = payload.items;
          total = Number(
            payload.count || payload.totalCount || payload.total || rows.length
          );
        } else if (payload && Array.isArray(payload.list)) {
          rows = payload.list;
          total = Number(
            payload.count || payload.totalCount || payload.total || rows.length
          );
        }

        this.availList = rows.map((row) => ({
          ...row,
          isActive: row.isActive !== false && row.isActive !== 0,
        }));
        this.availTotal = total;
      } catch (e) {
        console.error("StudentAvailability load failed:", e);
        this.availList = [];
        this.availTotal = 0;
      } finally {
        this.availLoading = false;
      }
    },

    changeAvailPage(page) {
      this.availPage = page;
      this.loadStudentAvailability();
    },

    editStudentAvailability(item) {
      const classIDs = this.parseAvailIds(item.classIDs || item.classIds);
      const sectionIDs = this.parseAvailIds(item.sectionIDs || item.sectionIds);
      const days = String(item.days || "")
        .split(",")
        .map((d) => d.trim())
        .filter(Boolean);

      this.availObj = {
        id: Number(item.id) || 0,
        classIDs: classIDs.length ? classIDs : [0],
        sectionIDs: sectionIDs.length ? sectionIDs : [0],
        days,
        status: "Off",
      };

      if (
        this.availObj.classIDs.length === 1 &&
        this.availObj.classIDs[0] !== 0
      ) {
        const obj = this.classes.find(
          (el) => el.cls.id == this.availObj.classIDs[0]
        );
        if (obj && obj.sections.length > 0) {
          this.availSecOptions = [
            { section: "All Sections", id: 0 },
            ...obj.sections,
          ];
        } else {
          this.availSecOptions = [{ section: "All Sections", id: 0 }];
        }
      } else {
        this.availSecOptions = [{ section: "All Sections", id: 0 }];
      }
    },

    async saveStudentAvailability() {
      if (!this.availObj.classIDs.length) {
        return this.$bvToast.toast("Please select class", {
          title: "Error!",
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
      if (!this.availObj.sectionIDs.length) {
        return this.$bvToast.toast("Please select section", {
          title: "Error!",
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
      if (!this.availObj.days.length) {
        return this.$bvToast.toast("Please select days", {
          title: "Error!",
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }

      this.availSaving = true;
      try {
        const body = {
          id: Number(this.availObj.id) || 0,
          campusID: Number(this.$store.state.userData.cId) || 0,
          classIDs: this.joinAvailIds(this.availObj.classIDs),
          sectionIDs: this.joinAvailIds(this.availObj.sectionIDs),
          days: this.availObj.days.join(","),
          status: "Off",
        };

        const status = await this.post({
          url:
            this.$store.state.domain +
            "StudentAvailability/Save?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&userID=" +
            this.$store.state.userData.userID,
          body,
          message:
            body.id > 0
              ? "Days setting updated successfully."
              : "Days setting saved successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });

        if (status) {
          this.resetAvailForm();
          this.loadStudentAvailability();
        }
      } finally {
        this.availSaving = false;
      }
    },

    async deleteStudentAvailability(item) {
      const ok = await this.$bvModal.msgBoxConfirm(
        "Are you sure you want to delete this days setting?",
        {
          title: "Confirm Delete",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          okVariant: "danger",
          centered: true,
        }
      );
      if (!ok) return;

      this.availDeleting = item.id;
      try {
        const status = await this.delete({
          url:
            this.$store.state.domain +
            "StudentAvailability/Delete?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&id=" +
            item.id,
          message: "Days setting deleted successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) {
          if (this.availObj.id === item.id) this.resetAvailForm();
          this.loadStudentAvailability();
        }
      } finally {
        this.availDeleting = null;
      }
    },

    async toggleAvailStatus(item, isActive) {
      this.availStatusUpdating = item.id;
      const previous = item.isActive;
      this.$set(item, "isActive", isActive);
      try {
        const status = await this.put({
          url:
            this.$store.state.domain +
            "StudentAvailability/SetStatus/" +
            this.$store.state.userData.cId +
            "/" +
            item.id +
            "/status?db=" +
            this.$store.state.userData.db +
            "&userID=" +
            this.$store.state.userData.userID,
          body: { isActive: !!isActive },
          message: isActive
            ? "Days setting activated."
            : "Days setting deactivated.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (!status) {
          this.$set(item, "isActive", previous);
        }
      } catch (e) {
        this.$set(item, "isActive", previous);
      } finally {
        this.availStatusUpdating = null;
      }
    },

    setHoliDept() {
      if (this.holiObj.departmentIDs.at(-1) == 0) {
        this.holiObj.departmentIDs = [0];
      } else {
        this.holiObj.departmentIDs = this.holiObj.departmentIDs.filter(
          (el) => el != 0
        );
      }
    },
    setHoliClass() {
      if (this.holiObj.clsIDs.at(-1) == 0) {
        this.holiObj.clsIDs = [0];
        this.holiSecOptions = [{ section: "All Sections", id: 0 }];
        this.holiObj.secIDs = [0];
      } else {
        this.holiObj.clsIDs = this.holiObj.clsIDs.filter((el) => el != 0);

        if (this.holiObj.clsIDs.length == 1) {
          let obj = this.classes.find(
            (el) => el.cls.id == this.holiObj.clsIDs[0]
          );
          if (obj && obj.sections.length > 0) {
            this.holiSecOptions = [...obj.sections];
            this.holiSecOptions.unshift({ section: "All Sections", id: 0 });
          } else {
            this.holiSecOptions = [{ section: "All Sections", id: 0 }];
          }
          this.holiObj.secIDs = [0];
        } else {
          this.holiSecOptions = [{ section: "All Sections", id: 0 }];
          this.holiObj.secIDs = [0];
        }
      }
    },
    setHoliSections() {
      if (this.holiObj.secIDs.at(-1) == 0) {
        this.holiObj.secIDs = [0];
      } else {
        this.holiObj.secIDs = this.holiObj.secIDs.filter((el) => el != 0);
      }
    },
    async markAttendanceStatus() {
      if (
        !this.holiObj.statusType ||
        !this.holiObj.dtFrom ||
        !this.holiObj.dtTo ||
        this.holiObj.clsIDs.length == 0 ||
        this.holiObj.secIDs.length == 0
      ) {
        return this.$bvToast.toast(
          this.$t("Please select all the required fields"),
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          }
        );
      }
      if (this.holiObj.dtFrom > this.holiObj.dtTo) {
        return this.$bvToast.toast("Please select the date correctly!", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }

      this.marking = true;

      const cls = this.holiObj.clsIDs[0] == 0 ? [] : this.holiObj.clsIDs;
      const sec = this.holiObj.secIDs[0] == 0 ? [] : this.holiObj.secIDs;
      const statusType = this.holiObj.statusType;
      const isOff = statusType === "off";
      const usesMarkHoliday = !isOff;

      const defaultReasonByStatus = {
        holiday: "Holiday",
        EXL: "Exam Leave",
        STL: "Study Leave",
      };
      const successMessageByStatus = {
        holiday: "Attendance marked as holiday",
        EXL: "Exam leave marked successfully!",
        STL: "Study leave marked successfully!",
        off: "Off attendance marked successfully!",
      };

      const payload = {
        dtFrom: this.holiObj.dtFrom,
        dtTo: this.holiObj.dtTo,
        clsIDs: cls,
        secIDs: sec,
        userID: this.$store.state.userData.userID,
      };
      if (usesMarkHoliday) {
        payload.reason =
          (this.holiObj.reason || "").trim() ||
          defaultReasonByStatus[statusType] ||
          "Holiday";
        if (statusType === "EXL" || statusType === "STL") {
          payload.status = statusType;
        }
      }

      const endpoint = usesMarkHoliday
        ? "Attendance/MarkHolidayByClass"
        : "Attendance/MarkSundayByClass";
      const successMessage =
        successMessageByStatus[statusType] ||
        successMessageByStatus.holiday;

      const postUrl =
        this.$store.state.domain +
        endpoint +
        "?db=" +
        this.$store.state.userData.db +
        "&cID=" +
        this.$store.state.userData.cId;

      if (usesMarkHoliday) {
        const result = await this.post({
          url: postUrl,
          body: payload,
          context: this,
          token: this.$store.state.userData.token,
          message: successMessage,
          returnData: true,
        });
        this.marking = false;
        if (result) {
          this.visibility6 = false;
          this.holidaySummary = result;
          this.holidaySummaryVisible = true;
          if (this.showGrid) {
            this.loadgrid();
          }
        }
        return;
      }

      const status = await this.post({
        url: postUrl,
        body: payload,
        context: this,
        token: this.$store.state.userData.token,
        message: successMessage,
        showError: true,
      });
      this.marking = false;
      if (status) {
        this.visibility6 = false;
        if (this.showGrid) {
          this.loadgrid();
        }
      }
    },

    getStudentHolidayHistoryCampusId() {
      if (Number(this.$store.state.userData.cId) === 1) return 0;
      return this.$store.state.userData.cId;
    },

    mapMarkStatusToHistoryFilter(statusType) {
      if (statusType === "holiday") return "H";
      if (statusType === "off") return "Off";
      if (statusType === "EXL" || statusType === "STL") return statusType;
      return "";
    },

    holidayHistoryStatusLabel(code) {
      const key = String(code || "").trim();
      if (!key) return "—";
      const map = {
        H: "Holiday",
        EXL: "Exam Leave",
        STL: "Study Leave",
        Off: "Off",
      };
      return map[key] || key;
    },

    holidayHistoryStatusVariant(code) {
      const key = String(code || "")
        .trim()
        .toUpperCase();
      if (key === "H") return "info";
      if (key === "EXL") return "dark";
      if (key === "STL") return "primary";
      if (key === "OFF") return "secondary";
      return "light";
    },

    resolveHolidayHistoryRowStatus(row) {
      if (!row) return "";
      return row.leaveStatus || row.status || row.eventType || "";
    },

    holidayHistoryRowId(row) {
      if (!row) return null;
      if (row.calendarId != null && row.calendarId !== "") {
        return row.calendarId;
      }
      if (row.calendarID != null && row.calendarID !== "") {
        return row.calendarID;
      }
      return row.id != null ? row.id : null;
    },

    getHolidayHistoryDeleteCampusId(row) {
      const rowCampus = row && row.campusID;
      if (rowCampus != null && Number(rowCampus) > 0) {
        return Number(rowCampus);
      }
      const histCampus = this.getStudentHolidayHistoryCampusId();
      if (histCampus != null && Number(histCampus) > 0) {
        return Number(histCampus);
      }
      return this.$store.state.userData.cId;
    },

    formatHolidayHistoryCampus(row) {
      if (!row) return "—";
      if (row.branch) return row.branch;
      if (row.campusName) return row.campusName;
      if (Number(row.campusID) === 0) return "All Campuses";
      return "—";
    },

    extractHolidayHistoryStatusOptions(res) {
      if (res == null || typeof res !== "object") return [];
      const payload =
        res.data && typeof res.data === "object" && !Array.isArray(res.data)
          ? res.data
          : res;
      const raw = payload.statusOptions || res.statusOptions;
      if (!Array.isArray(raw) || !raw.length) return [];
      return raw
        .map((item) => {
          if (item == null) return null;
          if (typeof item === "string" || typeof item === "number") {
            const value = String(item).trim();
            if (!value) return null;
            return {
              label: this.holidayHistoryStatusLabel(value) + " (" + value + ")",
              value,
            };
          }
          if (typeof item === "object") {
            const value = String(
              item.value != null
                ? item.value
                : item.code != null
                ? item.code
                : item.status != null
                ? item.status
                : item.id != null
                ? item.id
                : ""
            ).trim();
            if (!value || value === "[object Object]") return null;
            const labelRaw = item.label || item.text || item.name || item.title;
            const label =
              labelRaw && typeof labelRaw !== "object"
                ? String(labelRaw)
                : this.holidayHistoryStatusLabel(value) + " (" + value + ")";
            return { label, value };
          }
          return null;
        })
        .filter(Boolean);
    },

    openStudentHolidayHistory() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const lastDay = new Date(year, now.getMonth() + 1, 0).getDate();
      this.studentHolidayHistoryFilters = {
        dtFrom: this.holiObj.dtFrom || `${year}-${month}-01`,
        dtTo:
          this.holiObj.dtTo ||
          `${year}-${month}-${String(lastDay).padStart(2, "0")}`,
        status: this.mapMarkStatusToHistoryFilter(this.holiObj.statusType),
      };
      this.studentHolidayHistoryVisible = true;
      this.loadStudentHolidayHistory(1);
    },

    resetStudentHolidayHistoryFilters() {
      this.studentHolidayHistoryFilters = {
        dtFrom: "",
        dtTo: "",
        status: "",
      };
      this.loadStudentHolidayHistory(1);
    },

    normalizeStudentHolidayHistoryResponse(res) {
      if (res == null) return { items: [], total: 0, page: 1 };
      if (Array.isArray(res)) {
        return { items: res, total: res.length, page: 1 };
      }
      if (typeof res !== "object") return { items: [], total: 0, page: 1 };
      const payload = res.data && !Array.isArray(res.data) ? res.data : res;
      const items = Array.isArray(payload.data)
        ? payload.data
        : Array.isArray(payload.items)
        ? payload.items
        : Array.isArray(res.data)
        ? res.data
        : [];
      const total =
        Number(
          payload.filteredTotal ??
            payload.totalCount ??
            payload.totalRecords ??
            payload.total ??
            res.filteredTotal ??
            res.totalCount ??
            res.total ??
            items.length
        ) || 0;
      const page = Number(payload.page ?? res.page ?? 1) || 1;
      return { items, total, page };
    },

    async loadStudentHolidayHistory(page = 1) {
      this.studentHolidayHistoryPage = Math.max(1, Number(page) || 1);
      this.studentHolidayHistoryLoading = true;
      try {
        const params = new URLSearchParams({
          db: this.$store.state.userData.db,
          cID: String(this.getStudentHolidayHistoryCampusId()),
          page: String(this.studentHolidayHistoryPage),
          pageSize: String(this.studentHolidayHistoryPageSize),
        });
        if (this.studentHolidayHistoryFilters.dtFrom) {
          params.set("dtFrom", this.studentHolidayHistoryFilters.dtFrom);
        }
        if (this.studentHolidayHistoryFilters.dtTo) {
          params.set("dtTo", this.studentHolidayHistoryFilters.dtTo);
        }
        if (this.studentHolidayHistoryFilters.status) {
          params.set(
            "status",
            String(this.studentHolidayHistoryFilters.status)
          );
        }
        const raw = await this.get({
          url:
            this.$store.state.domain +
            "Attendance/StudentHolidayHistory?" +
            params.toString(),
          token: this.$store.state.userData.token,
          dashboard: true,
        });
        const normalized = this.normalizeStudentHolidayHistoryResponse(raw);
        const statusOpts = this.extractHolidayHistoryStatusOptions(raw);
        if (statusOpts.length) {
          this.studentHolidayHistoryStatusOptions = statusOpts;
        }
        this.studentHolidayHistoryItems = normalized.items;
        this.studentHolidayHistoryTotal = normalized.total;
        if (normalized.page > 0) {
          this.studentHolidayHistoryPage = normalized.page;
        }
      } catch (e) {
        console.error("loadStudentHolidayHistory:", e);
        this.studentHolidayHistoryItems = [];
        this.studentHolidayHistoryTotal = 0;
      } finally {
        this.studentHolidayHistoryLoading = false;
      }
    },

    formatStudentHolidayDate(value) {
      if (!value) return "—";
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return String(value).slice(0, 10);
      return d.toLocaleDateString("en-UK", {
        year: "numeric",
        day: "numeric",
        month: "short",
      });
    },

    formatStudentHolidayDateTime(value) {
      if (!value) return "—";
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return String(value);
      return d.toLocaleString("en-UK", {
        year: "numeric",
        day: "numeric",
        month: "short",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    },

    formatStudentHolidayIdList(value, allLabel) {
      if (value == null || value === "") return allLabel;
      if (Array.isArray(value)) {
        if (!value.length || (value.length === 1 && Number(value[0]) === 0)) {
          return allLabel;
        }
        return value.join(", ");
      }
      if (typeof value === "string") {
        const trimmed = value.trim();
        if (!trimmed || trimmed === "0" || trimmed === "[]") return allLabel;
        return trimmed;
      }
      return String(value);
    },

    formatStudentHolidayClasses(value) {
      return this.formatStudentHolidayIdList(value, "All Classes");
    },

    formatStudentHolidaySections(value) {
      return this.formatStudentHolidayIdList(value, "All Sections");
    },

    async deleteStudentHolidayHistory(row) {
      const calendarId = this.holidayHistoryRowId(row);
      if (!calendarId) return;
      const result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t(
          "This will remove the holiday calendar entry and related holiday attendance."
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });
      if (!result.isConfirmed) return;

      this.studentHolidayHistoryDeletingId = calendarId;
      try {
        const cID = this.getHolidayHistoryDeleteCampusId(row);
        const params = new URLSearchParams({
          db: this.$store.state.userData.db,
          cID: String(cID),
          id: String(calendarId),
          userID: String(this.$store.state.userData.userID || 0),
        });
        const status = await this.post({
          url:
            this.$store.state.domain +
            "Attendance/DeleteStudentHoliday?" +
            params.toString(),
          body: null,
          context: this,
          token: this.$store.state.userData.token,
          message: "Deleted successfully.",
        });
        if (status) {
          await this.loadStudentHolidayHistory(this.studentHolidayHistoryPage);
          if (this.showGrid) this.loadgrid();
        }
      } catch (e) {
        console.error("deleteStudentHolidayHistory:", e);
      } finally {
        this.studentHolidayHistoryDeletingId = null;
      }
    },

    async setAttendance() {
      this.settingAttendance = true;

      // Prepare the request data - using Saturday date (25th)
      const saturdayDate = "2025-10-26"; // Saturday date
      const requestData = {
        type: "student",
        dtFrom: saturdayDate,
        dtTo: saturdayDate,
        clsIDs: [],
        secIDs: [],
      };

      // API endpoint details
      const apiUrl =
        "https://apiv26.myskool.app/api/Attendance/LoadAndSaveAttendance";
      const queryParams = {
        db: this.$store.state.userData.db,
        cID: this.$store.state.userData.cId,
      };

      // Log all the request details to console
      console.log("=== SET ATTENDANCE API REQUEST DETAILS ===");
      console.log("API URL:", apiUrl);
      console.log("Method: POST");
      console.log("Query Parameters:", queryParams);
      console.log("Request Body (JSON):", JSON.stringify(requestData, null, 2));
      console.log(
        "Full URL with query params:",
        `${apiUrl}?db=${encodeURIComponent(queryParams.db)}&cID=${
          queryParams.cID
        }`
      );
      console.log("==========================================");

      try {
        // Make the actual API call - using the same format as other API calls in the file
        const response = await this.post({
          url: `${apiUrl}?db=${queryParams.db}&cID=${queryParams.cID}`,
          body: requestData,
          context: this,
          token: this.$store.state.userData.token,
          message: "Attendance loaded and saved successfully!",
        });

        console.log("API Response:", response);

        this.$bvToast.toast("Attendance processed successfully!", {
          title: "Success!",
          variant: "success",
          toaster: "b-toaster-top-center",
        });
      } catch (error) {
        console.error("API Error:", error);
        this.$bvToast.toast("Failed to process attendance. Please try again.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }

      this.settingAttendance = false;
    },

    openSett() {
      this.visibility5 = true;
    },
    async saveChecks() {
      // console.log(this.checkInObj, this.checkOutObj);
      this.savingCh = true;
      var status = await this.post({
        url:
          this.$store.state.domain +
          "Settings/SaveNew?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: [this.checkInObj, this.checkOutObj],
        message: "Settings saved successfully.",
        context: this,
        token: this.$store.state.userData.token,
      });
      this.savingCh = false;
      if (status) {
        this.loadOther();
        this.visibility5 = false;
      }
    },

    sortData() {
      this.$store.commit("setAttSort", this.sortBy);

      if (this.sortBy == "gr") {
        this.gridData = this.gridData.sort((a, b) =>
          a.grNo
            .toLowerCase()
            .localeCompare(b.grNo.toLowerCase(), "en", { numeric: true })
        );
      } else {
        this.gridData = this.gridData.sort((a, b) =>
          a.name
            .toLowerCase()
            .localeCompare(b.name.toLowerCase(), "en", { numeric: true })
        );
      }
    },

    async loadOtherAll() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettingsAll?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: ["hideDuesAlert", "student_day_setting"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      // console.log(res);
      let obj = (res || []).find((el) => el.key == "hideDuesAlert");
      this.hideDuesAlert = obj ? obj.valueBool : false;
      this.daySettingObj =
        (res || []).find((el) => el.key == "student_day_setting") || null;
    },
    async loadOther() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettings?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: [
          "picture_size",
          "check_in",
          "check_out",
          "studentTimings",
          "unmarked-attendance",
        ],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      // console.log(res);
      this.picObj = res.find((el) => el.key == "picture_size");
      this.timeObj = res.find((el) => el.key == "studentTimings");
      this.unMObj = res.find((el) => el.key == "unmarked-attendance");
      if (this.timeObj && this.timeObj.valueBool) this.checkTime = true;
      else this.checkTime = false;
      // this.syncObj = res.find((el) => el.key == "attendance_sync");
      // console.log(this.syncObj);

      let a = res.find((el) => el.key == "check_in");
      if (!a) {
        this.checkInObj = {
          id: 0,
          campusID: this.$store.state.userData.cId,
          key: "check_in",
          value: "check_in",
          valueBool: false,
          valueNumber: null,
        };
      } else this.checkInObj = a;

      let b = res.find((el) => el.key == "check_out");
      if (!b) {
        this.checkOutObj = {
          id: 0,
          campusID: this.$store.state.userData.cId,
          key: "check_out",
          value: "check_out",
          valueBool: false,
          valueNumber: null,
        };
      } else this.checkOutObj = b;
      // console.log(this.checkInObj, this.checkOutObj);
      let obj = this.fields.find((el) => el.label == "time in");
      if (this.checkInObj.id > 0 && !this.checkInObj.valueBool && obj) {
        this.fields = this.fields.filter((el) => el.label != "time in");
      }
      if (this.checkInObj.id > 0 && this.checkInObj.valueBool && !obj) {
        this.fields.splice(5, 0, { label: "time in", key: "timein" });
      }

      let obj2 = this.fields.find((el) => el.label == "time out");
      if (this.checkOutObj.id > 0 && !this.checkOutObj.valueBool && obj2) {
        this.fields = this.fields.filter((el) => el.label != "time out");
      }
      if (this.checkOutObj.id > 0 && this.checkOutObj.valueBool && !obj2) {
        this.fields.splice(this.fields.length - 1, 0, {
          label: "time out",
          key: "timeout",
        });
      }
    },
    async loadAll() {
      this.dataLoading = true;

      // LoadAllStudents
      var obj = {
        url:
          this.$store.state.domain +
          "Attendance/LoadAllStudentsPagination?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&pageNo=1",
        token: this.$store.state.userData.token,
        dashboard: true,
      };
      let res = await this.get(obj);
      // console.log(res);
      if (Array.isArray(res)) {
        this.allStudents = [];
        this.totalCount = 0;
      } else {
        this.allStudents = res.data;
        this.totalCount = res.count;
      }
      if (this.totalCount > 100) {
        await this.LoadMore();
      }
      this.intervalId = setInterval(this.syncAtt, 31000);
      // console.log(this.intervalId);

      this.dataLoading = false;
    },
    async LoadMore() {
      const count = Math.ceil(this.totalCount / 100);
      this.isLoopRunning = true;
      try {
        // Create array of promises for all pages starting from page 2
        const promises = [];
        for (let i = 2; i <= count; i++) {
          if (!this.isLoopRunning) break;

          const promise = this.get({
            url:
              this.$store.state.domain +
              "Attendance/LoadAllStudentsPagination?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId +
              "&pageNo=" +
              i,
            token: this.$store.state.userData.token,
          });
          promises.push(promise);
        }

        // Wait for all requests to complete
        const responses = await Promise.all(promises);

        // Combine all responses into allStudents array
        const newStudents = responses.flat();
        this.allStudents = [...this.allStudents, ...newStudents];
      } finally {
        this.isLoopRunning = false;
        // const duplicateNames = [
        //   ...new Set(
        //     this.allStudents
        //       .map((item) => item.std.id)
        //       .filter((id, _, arr) => arr.filter((n) => n === id).length > 1)
        //   ),
        // ];
        // console.log(duplicateNames);
      }
    },
    async loadAllStaff() {
      var obj = {
        url:
          this.$store.state.domain +
          "Attendance/LoadAllStaff?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
        dashboard: true,
      };
      let res = await this.get(obj);
      this.allStaff = res.dataNew ? res.dataNew : res.data;
      // console.log(this.allStaff);
    },
    async syncAtt() {
      // console.log("syncing");
      if (this.syncData.length > 0) {
        this.syncing = true;
        let temp = [...this.syncData];
        this.syncData = [];
        this.$store.commit("setSyncList", []);

        let data = temp.map((el) => ({
          id: el.std.grNo,
          time: el.time,
        }));
        // console.log(data);

        var status = await this.post({
          url:
            this.$store.state.domain +
            "Attendance/SyncAttendance?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&userID=" +
            this.$store.state.userData.userID,
          body: data,
          message: "Attendance saved successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });

        if (!status) {
          this.syncData = [...this.syncData, ...temp];
          this.$store.commit("setSyncList", this.syncData);
        }

        this.syncing = false;
      }
      if (this.staffData.length > 0) {
        this.syncing = true;
        let temp = [...this.staffData];
        this.staffData = [];
        this.$store.commit("setStaffSyncList", []);

        let data = temp.map((el) => ({
          id: el.staff.id.toString(),
          time: el.time,
        }));
        // console.log(data);

        var status2 = await this.post({
          url:
            this.$store.state.domain +
            "Attendance/SyncAttendanceStaff?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&userID=" +
            this.$store.state.userData.userID,
          body: data,
          message: "Attendance saved successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });

        if (!status2) {
          this.staffData = [...this.staffData, ...temp];
          this.$store.commit("setStaffSyncList", this.staffData);
        }

        this.syncing = false;
      }
      //  else {
      //   this.$bvToast.toast("No record to sync", {
      //     title: this.$t("Error!"),
      //     variant: "danger",
      //     toaster: "b-toaster-top-center",
      //   });
      // }
    },

    async loadSessions() {
      var obj = {
        url:
          this.$store.state.domain +
          "Sessions?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.sessions = await this.get(obj);
      let res = this.sessions.find((el) => el.isCurrentSession);
      this.sessionID = res ? res.id : 0;
    },
    changeAtt(ind, val) {
      this.filteredAtt[ind].obj.status = val;
    },
    async save() {
      if (this.gridData.length != 0) {
        this.saving = true;
        this.gridData.forEach((el) => {
          let inValue = !el.inputTimein
            ? null
            : `${el.obj.date.split("T")[0]}T${el.inputTimein.split("T")[1]}`;

          let outValue = !el.inputTimeout
            ? null
            : `${el.obj.date.split("T")[0]}T${el.inputTimeout.split("T")[1]}`;

          el.inputTimein = inValue;
          el.inputTimeout = outValue;
          el.obj.timeIn = inValue;
          el.obj.timeOut = outValue;
        });

        var status = await this.post({
          url:
            this.$store.state.domain +
            "Attendance/SaveWeb?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: this.gridData,
          message: "Attendance saved successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.saving = false;
        if (status) {
          this.loadgrid();
        }
      }
    },
    async checkPrint(text) {
      if (this.gridData.length === 0) {
        this.$bvToast.toast("No attendance data to send notification.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      if (text == "notification") {
        // Reset status to "A" (Absent) by default
        this.notificationStatus = "A";
        this.showNotificationModal = true;
      }
    },
    confirmSendNotification() {
      // Get selected status - if "All" is selected, it will be empty string ""
      const selectedStatus = this.notificationStatus || "A";
      this.showNotificationModal = false;
      this.sendNotification(selectedStatus);
    },
    async sendNotification(selectedStatus = "A") {
      this.iNotification = true;

      try {
        // First, save the attendance
        if (this.gridData.length != 0) {
          this.gridData.forEach((el) => {
            let inValue = !el.inputTimein
              ? null
              : `${el.obj.date.split("T")[0]}T${el.inputTimein.split("T")[1]}`;

            let outValue = !el.inputTimeout
              ? null
              : `${el.obj.date.split("T")[0]}T${el.inputTimeout.split("T")[1]}`;

            el.inputTimein = inValue;
            el.inputTimeout = outValue;
            el.obj.timeIn = inValue;
            el.obj.timeOut = outValue;
          });

          var status = await this.post({
            url:
              this.$store.state.domain +
              "Attendance/SaveWeb?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId,
            body: this.gridData,
            context: this,
            token: this.$store.state.userData.token,
          });

          if (status) {
            this.loadgrid();
          }
        }

        // Prepare class and section IDs for notification
        let clsIDs = [];
        let secIDs = [];

        if (this.classID[0] !== 0) {
          clsIDs = this.classID;
        } else {
          clsIDs = [];
        }

        if (this.secID[0] !== 0) {
          secIDs = this.secID;
        } else {
          secIDs = [];
        }

        // Get current date for notification (format: Y-m-d, e.g., "2025-11-13")
        let currentDate = this.datepickr;
        if (!currentDate) {
          const today = new Date();
          currentDate = `${today.getFullYear()}-${String(
            today.getMonth() + 1
          ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
        }
        // Ensure date format is Y-m-d
        if (currentDate.includes("T")) {
          currentDate = currentDate.split("T")[0];
        }

        // Prepare notification payload
        // API: POST /api/Attendance/SendNotification?db={encrypted_db}&cID={campusID}
        const notificationObj = {
          dt: currentDate, // Date in format "2025-11-13"
          clsIDs: clsIDs, // Array of class IDs, e.g., [1, 2, 3]
          secIDs: secIDs, // Array of section IDs, e.g., [1, 5] or []
        };

        // Only include status if it's not "All" (not empty string)
        if (selectedStatus && selectedStatus !== "") {
          notificationObj.status = selectedStatus;
        }

        // Send notification using Attendance/SendNotification endpoint
        var notificationStatus = await this.post({
          url:
            this.$store.state.domain +
            "Attendance/SendNotification?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: notificationObj,
          context: this,
          token: this.$store.state.userData.token,
        });

        if (notificationStatus) {
          this.$bvToast.toast(
            "Attendance applied and notification sent successfully!",
            {
              title: "Success!",
              variant: "success",
              toaster: "b-toaster-top-center",
            }
          );
        }
      } catch (error) {
        console.error("Error sending notification:", error);
        this.$bvToast.toast("Failed to send notification. Please try again.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } finally {
        this.iNotification = false;
      }
    },
    openDetails() {
      this.showreport = true;
      this.report.type = "student";
      this.showClasses = true;
    },
    setType(val) {
      this.report.type = val;
      if (this.report.type == "student") this.showClasses = true;
      else this.showClasses = false;
    },

    setTime() {
      console.log(this.timePicker);
      console.log(this.datepickr);
    },

    openMessage() {
      this.msgObj = {
        dt: "",
        clsIDs: [0],
        secIDs: [0],
        status: "A",
      };
      this.visibility2 = true;

      var elem = this.$refs["msg_class"];
      elem.state = undefined;
      // var elem = this.$refs["msg_section"];
      // elem.state = undefined;
      var elem = this.$refs["msg_date"];
      elem.state = undefined;
    },

    async saveMessage() {
      // console.log(this.msgObj);
      if (
        this.msgClass.length == 0 ||
        this.msgSection.length == 0 ||
        this.msgObj.dt == ""
      ) {
        return this.$bvToast.toast(
          this.$t("Please select all the required fields"),
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          }
        );
      } else {
        if (this.msgClass[0] !== 0) {
          this.msgObj.clsIDs = this.msgClass;
        } else {
          this.msgObj.clsIDs = [];
        }
        if (this.msgSection[0] !== 0) {
          //console.log(this.secID);
          this.msgObj.secIDs = this.msgSection;
        } else {
          this.msgObj.secIDs = [];
        }

        // Prepare payload - exclude status if it's "All" (empty string)
        const payload = {
          dt: this.msgObj.dt,
          clsIDs: this.msgObj.clsIDs,
          secIDs: this.msgObj.secIDs,
        };

        // Only include status if it's not "All" (not empty string)
        if (this.msgObj.status && this.msgObj.status !== "") {
          payload.status = this.msgObj.status;
        }

        this.request = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Attendance/SendMessage?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: payload,
          message: "Message send successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        if (status) {
          this.visibility2 = false;
        }
      }
    },
    async sendNotificationFromSidebar() {
      if (
        this.msgClass.length == 0 ||
        this.msgSection.length == 0 ||
        this.msgObj.dt == ""
      ) {
        return this.$bvToast.toast(
          this.$t("Please select all the required fields"),
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          }
        );
      } else {
        let clsIDs = [];
        let secIDs = [];

        if (this.msgClass[0] !== 0) {
          clsIDs = this.msgClass;
        } else {
          clsIDs = [];
        }
        if (this.msgSection[0] !== 0) {
          secIDs = this.msgSection;
        } else {
          secIDs = [];
        }

        const payload = {
          dt: this.msgObj.dt,
          clsIDs: clsIDs,
          secIDs: secIDs,
        };

        if (this.msgObj.status && this.msgObj.status !== "") {
          payload.status = this.msgObj.status;
        }

        this.iNotification = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Attendance/SendNotification?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: payload,
          message: "Notification sent successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.iNotification = false;
        if (status) {
          this.visibility2 = false;
        }
      }
    },
    FillMsgSections() {
      // console.log(this.msgClass);
      if (this.msgClass[0] == 0 && this.msgClass.length !== 1) {
        this.msgClass = this.msgClass.filter((e) => e !== 0);
        // console.log(this.msgClass);
        this.classes.forEach((elem) => {
          if (this.msgClass.includes(elem.cls.id)) {
            if (elem.sections.length != 0) {
              elem.sections.forEach((el) => this.msgSecOptions.push(el));
            } else {
              // console.log("null");
              this.msgSecOptions = [{ section: "All Sections", id: 0 }];
            }
          }
        });
      } else if (
        this.msgClass[this.msgClass.length - 1] !== 0 &&
        this.msgClass.length == 1
      ) {
        this.classes.forEach((elem) => {
          if (this.msgClass.includes(elem.cls.id)) {
            if (elem.sections.length != 0) {
              elem.sections.forEach((el) => this.msgSecOptions.push(el));
            } else {
              // console.log("null");
              this.msgSecOptions = [{ section: "All Sections", id: 0 }];
            }
          }
        });
      } else if (this.msgClass[this.msgClass.length - 1] == 0) {
        this.msgClass = [0];
        // console.log(this.msgClass);
        this.msgSecOptions = [{ section: "All Sections", id: 0 }];
        this.msgSection = [0];
      } else {
        this.msgSecOptions = [{ section: "All Sections", id: 0 }];
        this.msgSection = [0];
      }
      // this.CheckClass();
    },
    checkMsgSections() {
      // console.log(this.msgSection);
      if (this.msgSection[0] == 0 && this.msgSection.length !== 1) {
        this.msgSection = this.msgSection.filter((e) => e !== 0);
        // console.log(this.msgSection);
      } else if (this.msgSection[this.msgSection.length - 1] == 0) {
        this.msgSection = [0];
        // console.log(this.msgSection);
      }
    },

    FillSections() {
      //   if (this.classID.includes(0) && this.classID.length == 2) {
      //     this.classID = this.classID.filter((e) => e !== 0);
      //     console.log(this.classID);
      //   }

      // console.log(this.classID);
      if (this.classID[0] == 0 && this.classID.length !== 1) {
        this.classID = this.classID.filter((e) => e !== 0);
        // console.log(this.classID);
        this.classes.forEach((elem) => {
          if (this.classID.includes(elem.cls.id)) {
            if (elem.sections.length != 0) {
              elem.sections.forEach((el) => this.admittedSections.push(el));
            } else {
              // console.log("null");
              this.admittedSections = [{ section: "All Sections", id: 0 }];
            }
          }
        });
      } else if (
        this.classID[this.classID.length - 1] !== 0 &&
        this.classID.length == 1
      ) {
        this.classes.forEach((elem) => {
          if (this.classID.includes(elem.cls.id)) {
            if (elem.sections.length != 0) {
              elem.sections.forEach((el) => this.admittedSections.push(el));
            } else {
              // console.log("null");
              this.admittedSections = [{ section: "All Sections", id: 0 }];
            }
          }
        });
      } else if (this.classID[this.classID.length - 1] == 0) {
        this.classID = [0];
        // console.log(this.classID);
        this.admittedSections = [{ section: "All Sections", id: 0 }];
        this.secID = [0];
      } else {
        this.admittedSections = [{ section: "All Sections", id: 0 }];
        this.secID = [0];
      }
      // this.CheckClass();
    },
    checkSections() {
      // console.log(this.secID);
      if (this.secID[0] == 0 && this.secID.length !== 1) {
        this.secID = this.secID.filter((e) => e !== 0);
        // console.log(this.secID);
      } else if (this.secID[this.secID.length - 1] == 0) {
        this.secID = [0];
        // console.log(this.secID);
      }
      // this.CheckSec();
    },
    CheckSec() {
      var elem = this.$refs["section"];
      if (this.secID.length == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    FillRepSections() {
      // console.log(this.repClass);
      if (this.repClass[0] == 0 && this.repClass.length !== 1) {
        this.repClass = this.repClass.filter((e) => e !== 0);
        // console.log(this.repClass);
        this.classes.forEach((elem) => {
          if (this.repClass.includes(elem.cls.id)) {
            if (elem.sections.length != 0) {
              elem.sections.forEach((el) => this.repSecOptions.push(el));
            } else {
              // console.log("null");
              this.repSecOptions = [{ section: "All Sections", id: 0 }];
            }
          }
        });
      } else if (
        this.repClass[this.repClass.length - 1] !== 0 &&
        this.repClass.length == 1
      ) {
        this.classes.forEach((elem) => {
          if (this.repClass.includes(elem.cls.id)) {
            if (elem.sections.length != 0) {
              elem.sections.forEach((el) => this.repSecOptions.push(el));
            } else {
              // console.log("null");
              this.repSecOptions = [{ section: "All Sections", id: 0 }];
            }
          }
        });
      } else if (this.repClass[this.repClass.length - 1] == 0) {
        this.repClass = [0];
        // console.log(this.repClass);
        this.repSecOptions = [{ section: "All Sections", id: 0 }];
        this.repSection = [0];
      } else {
        this.repSecOptions = [{ section: "All Sections", id: 0 }];
        this.repSection = [0];
      }
      // this.CheckClass();
    },
    checkRepSections() {
      // console.log(this.repSection);
      if (this.repSection[0] == 0 && this.repSection.length !== 1) {
        this.repSection = this.repSection.filter((e) => e !== 0);
        // console.log(this.repSection);
      } else if (this.repSection[this.repSection.length - 1] == 0) {
        this.repSection = [0];
        // console.log(this.repSection);
      }
    },
    setRepDate(sd, dateStr) {
      // console.log(sd, dateStr);
      if (dateStr) {
        if (sd.length > 1) {
          let date = dateStr.split(" to ");
          if (date.length == 1) {
            this.repObj.dtFrom = date[0];
            this.repObj.dtTo = date[0];
          } else {
            this.repObj.dtFrom = date[0];
            this.repObj.dtTo = date[1];
          }
        } else {
          this.repObj.dtFrom = dateStr;
          this.repObj.dtTo = null;
        }
      } else {
        this.repObj.dtFrom = null;
        this.repObj.dtTo = null;
      }
      // console.log(this.repObj);
    },
    setStatus() {
      if (this.repObj.status[this.repObj.status.length - 1] == "") {
        this.repObj.status = [""];
      } else {
        this.repObj.status = this.repObj.status.filter((el) => el != "");
      }
      // console.log(this.repObj.status);
    },
    openReport() {
      const fd = new Date();
      const firstDate = `${fd.getFullYear()}-${(fd.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-01`;

      const ld = new Date(fd.getFullYear(), fd.getMonth() + 1, 0);
      const lastDate = `${ld.getFullYear()}-${(ld.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${ld.getDate().toString().padStart(2, "0")}`;

      // console.log(firstDate, lastDate);

      this.repObj = {
        type: "",
        dtFrom: firstDate,
        dtTo: lastDate,
        clsIDs: [0],
        secIDs: [0],
        status: [""],
      };
      this.repDate = `${firstDate} to ${lastDate}`;

      this.visibility3 = true;

      var elem = this.$refs["rep_class"];
      elem.state = undefined;
      // var elem = this.$refs["rep_section"];
      // elem.state = undefined;
      var elem = this.$refs["rep_date"];
      elem.state = undefined;
    },

    async getReport() {
      // console.log(this.repObj);
      if (
        this.repClass.length == 0 ||
        this.repSection.length == 0 ||
        this.repObj.status.length == 0 ||
        !this.repObj.dtFrom ||
        !this.repObj.dtTo
      ) {
        return this.$bvToast.toast(
          this.$t("Please select all the required fields"),
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          }
        );
      } else {
        let obj = {
          type: "student",
          dtFrom: this.repObj.dtFrom,
          dtTo: this.repObj.dtTo,
          clsIDs: [],
          secIDs: [],
        };
        if (this.repClass[0] !== 0) {
          this.repObj.clsIDs = this.repClass;
          obj.clsIDs = this.repClass;
        } else {
          this.repObj.clsIDs = "";
        }
        if (this.repSection[0] !== 0) {
          this.repObj.secIDs = this.repSection;
          obj.secIDs = this.repSection;
        } else {
          this.repObj.secIDs = "";
        }
        let status = "";
        if (this.repObj.status[0] !== "") {
          status = this.repObj.status;
        }
        this.request = true;

        if (this.unMObj && this.unMObj.valueBool) {
          var st = await this.post({
            url:
              this.$store.state.domain +
              "Attendance/SaveUnmarkedRange?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId,
            body: obj,
            importing: true,
            context: this,
            token: this.$store.state.userData.token,
          });
        }

        var url =
          `https://${this.reportDomain}.myskool.app/Attendance/Show?type=student&dtFrom=` +
          this.repObj.dtFrom +
          "&dtTo=" +
          this.repObj.dtTo +
          "&dbb=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&cls=" +
          this.repObj.clsIDs +
          "&sec=" +
          this.repObj.secIDs +
          "&status=" +
          status;

        window.open(url, "_blank");
        this.request = false;
        // if (status) {
        //   this.visibility3 = false;
        // }
      }
    },
    async exportReport() {
      // console.log(this.repObj);
      if (
        this.repClass.length == 0 ||
        this.repSection.length == 0 ||
        this.repObj.status.length == 0 ||
        !this.repObj.dtFrom ||
        !this.repObj.dtTo
      ) {
        return this.$bvToast.toast(
          this.$t("Please select all the required fields"),
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          }
        );
      } else {
        let obj = {
          type: "student",
          dtFrom: this.repObj.dtFrom,
          dtTo: this.repObj.dtTo,
          clsIDs: [],
          secIDs: [],
        };
        if (this.repClass[0] !== 0) {
          this.repObj.clsIDs = this.repClass;
          obj.clsIDs = this.repClass;
        } else {
          this.repObj.clsIDs = "";
        }
        if (this.repSection[0] !== 0) {
          this.repObj.secIDs = this.repSection;
          obj.secIDs = this.repSection;
        } else {
          this.repObj.secIDs = "";
        }
        let status = "";
        if (this.repObj.status[0] !== "") {
          status = this.repObj.status;
        }
        this.exporting = true;

        if (this.unMObj && this.unMObj.valueBool) {
          var st = await this.post({
            url:
              this.$store.state.domain +
              "Attendance/SaveUnmarkedRange?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId,
            body: obj,
            importing: true,
            context: this,
            token: this.$store.state.userData.token,
          });
        }

        var url =
          `https://${this.reportDomain}.myskool.app/Attendance/ShowExport?type=student&dtFrom=` +
          this.repObj.dtFrom +
          "&dtTo=" +
          this.repObj.dtTo +
          "&dbb=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&cls=" +
          this.repObj.clsIDs +
          "&sec=" +
          this.repObj.secIDs +
          "&status=" +
          status;

        axios
          .get(url)
          .then((response) => {
            if (response.data.status == "success") {
              window.open(response.data.data, "_blank");
            } else {
              this.$bvToast.toast("Something went wrong", {
                title: this.$t("Error!"),
                variant: "danger",
                toaster: "b-toaster-top-center",
              });
            }
          })
          .catch((error) => {
            console.error("There was an error!", error);
          })
          .finally(() => {
            this.exporting = false;
          });
      }
    },
    async getSheet() {
      if (this.repClass.length == 0 || this.repSection.length == 0) {
        return this.$bvToast.toast("Please select class and section", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        if (this.repClass[0] !== 0) {
          this.repObj.clsIDs = this.repClass;
        } else {
          this.repObj.clsIDs = "";
        }
        if (this.repSection[0] !== 0) {
          this.repObj.secIDs = this.repSection;
        } else {
          this.repObj.secIDs = "";
        }

        this.sheetLoading = true;
        if (this.$store.state.currentBranch.organizationType == "coaching") {
          var url =
            `https://${this.reportDomain}.myskool.app/List/Show?type=attendance&dbb=` +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&cls=" +
            this.repObj.clsIDs +
            "&sec=" +
            this.repObj.secIDs +
            "&session=" +
            this.sessionID +
            "&status=&mob=false";

          window.open(url, "_blank");
        } else {
          var url =
            `https://${this.reportDomain}.myskool.app/List/Show?type=attendance&dbb=` +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&cls=" +
            this.repObj.clsIDs +
            "&sec=" +
            this.repObj.secIDs +
            "&status=&mob=false";

          window.open(url, "_blank");
        }
        this.sheetLoading = false;
      }
    },
    async loadgrid() {
      this.gridLoading = true;
      this.showGrid = true;
      if (this.classID[0] !== 0) {
        this.report.clsIDs = this.classID;
      } else {
        this.report.clsIDs = [];
      }
      if (this.secID[0] !== 0) {
        //console.log(this.secID);
        this.report.secIDs = this.secID;
      } else {
        this.report.secIDs = [];
      }
      // console.log(this.report);
      this.request = true;
      var status = await this.post({
        url:
          this.$store.state.domain +
          "Attendance/LoadAttendanceGrid?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: this.report,
        attendance: true,
        context: this,
        token: this.$store.state.userData.token,
      });
      this.request = false;
      if (status) {
        this.gridData = status;
        this.gridData = this.gridData.map((el) => ({
          ...el,
          inputTimein: el.obj.timeIn,
          inputTimeout: el.obj.timeOut,
        }));
        this.sortData();
      }
      this.gridLoading = false;
    },
    async DeleteAtt() {
      if (
        this.classID.length > 0 &&
        this.secID.length > 0 &&
        this.report.dtFrom
      ) {
        let result = await Swal.fire({
          title: this.$t("Are you sure?"),
          text: this.$t("Do you want to delete the attendance?"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("Yes, Delete it!"),
        });

        if (result.isConfirmed) {
          this.deleting = true;
          if (this.classID[0] !== 0) {
            this.report.clsIDs = this.classID;
          } else {
            this.report.clsIDs = [];
          }
          if (this.secID[0] !== 0) {
            //console.log(this.secID);
            this.report.secIDs = this.secID;
          } else {
            this.report.secIDs = [];
          }
          var status = await this.post({
            url:
              this.$store.state.domain +
              "Attendance/DeleteAttendace?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId,
            message: "Attendance deleted successfully!",
            context: this,
            body: this.report,
            token: this.$store.state.userData.token,
          });
          this.deleting = false;
          if (status) {
            this.loadgrid();
          }
        }
      } else {
        this.$bvToast.toast(this.$t("Please select all required fields"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
    },
    async Edit(item) {
      this.attendance = item;
      // console.log(this.attendance);
      this.editAtt = true;
      this.datepickr = this.attendance.date.split("T")[0];
      this.timePicker = this.attendance.date.split("T")[1];

      var elem = this.$refs["account"];
      elem.state = undefined;
      var elem = this.$refs["balance"];
      elem.state = undefined;
    },
    async GetStudent() {
      if (this.studentID.length !== 0) {
        // sync setting
        if (this.syncObj && this.syncObj.valueBool) {
          this.studentLoading = true;
          if (
            this.studentID.toLowerCase().startsWith("e") ||
            this.studentID.endsWith("+")
          ) {
            let extractedNumber = this.studentID.replace(/[Ee+]/g, "");

            let stf = this.allStaff.find(
              (el) => el.staff.id.toString() == extractedNumber
            );
            // console.log(stf);
            if (stf) {
              this.currentStaff = { ...stf };
              let date = new Date();
              let day = new Date().toJSON().split("T")[0];
              let time = date.toTimeString().split(" ")[0];
              // console.log(time);
              this.currentStaff.time = day + "T" + time;
              this.currentStaff.isStaff = true; // for recent
              this.items.unshift(this.currentStaff);
              this.staffData.push(this.currentStaff);
              this.$store.commit("setStaffSyncList", this.staffData);

              if (this.checkTime && this.currentStaff.timings) {
                // check out
                if (this.currentStaff.toCheck == "out") {
                  let outTime = new Date(this.currentStaff.timings.timeOut)
                    .toTimeString()
                    .split(" ")[0];
                  // console.log("to: ", outTime);
                  if (time < outTime) {
                    this.currentStaff.isEarly = true;

                    let t1 = outTime.split(":").slice(0, 2).join(":");
                    let t2 = time.split(":").slice(0, 2).join(":");
                    // console.log("staff out", t1, t2);

                    const date1 = new Date(`2023-01-05T${t1}:00Z`);
                    const date2 = new Date(`2023-01-05T${t2}:00Z`);
                    const diffMs = date1 - date2;

                    // Convert milliseconds to hours, minutes, and seconds
                    const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
                    const diffMins = Math.floor(
                      (diffMs % (1000 * 60 * 60)) / (1000 * 60)
                    );
                    //const diffSecs = Math.floor((diffMs % (1000 * 60)) / 1000);

                    // console.log(`early diff: ${diffHrs} hrs, ${diffMins} mins`);
                    if (diffHrs > 0) {
                      this.currentStaff.delay = `${diffHrs} ${
                        diffHrs == 1 ? "hr" : "hrs"
                      } ${diffMins} ${diffMins > 1 ? "mins" : "min"} Early`;
                    } else {
                      this.currentStaff.delay = `${diffMins} ${
                        diffMins > 1 ? "mins" : "min"
                      } Early`;
                    }
                    // console.log("early");
                  } else {
                    this.currentStaff.isEarly = false;
                    // console.log("out time");
                  }
                } else {
                  // check in
                  let index = this.allStaff.indexOf(stf);
                  this.allStaff[index].toCheck = "out";

                  let inTime = new Date(this.currentStaff.timings.timeIn)
                    .toTimeString()
                    .split(" ")[0];
                  // console.log("in: ", inTime);
                  if (time > inTime) {
                    this.currentStaff.isLate = true;

                    let t1 = time.split(":").slice(0, 2).join(":");
                    let t2 = inTime.split(":").slice(0, 2).join(":");
                    // console.log("staff in", t1, t2);

                    const date1 = new Date(`2023-01-05T${t1}:00Z`);
                    const date2 = new Date(`2023-01-05T${t2}:00Z`);
                    const diffMs = date1 - date2;

                    // Convert milliseconds to hours, minutes, and seconds
                    const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
                    const diffMins = Math.floor(
                      (diffMs % (1000 * 60 * 60)) / (1000 * 60)
                    );
                    //const diffSecs = Math.floor((diffMs % (1000 * 60)) / 1000);

                    // console.log(`late diff: ${diffHrs} hrs, ${diffMins} mins`);
                    if (diffHrs > 0) {
                      this.currentStaff.delay = `${diffHrs} ${
                        diffHrs == 1 ? "hr" : "hrs"
                      } ${diffMins} ${diffMins > 1 ? "mins" : "min"} Late`;
                    } else {
                      this.currentStaff.delay = `${diffMins} ${
                        diffMins > 1 ? "mins" : "min"
                      } Late`;
                    }
                  } else {
                    this.currentStaff.isLate = false;
                    // console.log("in time");
                  }
                }
              }
            } else {
              this.currentStaff = null;
              this.$bvToast.toast("No staff found.", {
                title: this.$t("Error!"),
                variant: "danger",
                toaster: "b-toaster-top-center",
              });
            }
            this.currentStd = {
              std: {
                picture: null,
                cls: null,
                grNo: null,
                name: null,
              },
              dues: null,
            };
          } else {
            let extractedNumber = this.studentID
              .match(/\d+/)[0]
              .replace(/^0+/, "");
            // console.log(extractedNumber);
            let res = this.allStudents.find(
              (el) =>
                el.std.grNo &&
                el.std.grNo.match(/\d+/)[0].replace(/^0+/, "") ==
                  extractedNumber
            );
            //console.log("CURRENT STD: ", res);
            //console.log(res);
            if (res) {
              this.currentStd = { ...res };
              let date = new Date();
              let day = new Date().toJSON().split("T")[0];
              let time = date.toTimeString().split(" ")[0];
              this.currentStd.time = day + "T" + time;
              // console.log(this.currentStd.time);
              this.items.unshift(this.currentStd);
              this.syncData.push(this.currentStd);
              this.$store.commit("setSyncList", this.syncData);

              if (this.checkTime && this.currentStd.timings) {
                //Checkout
                if (this.currentStd.toCheck == "out") {
                  let outTime = new Date(this.currentStd.timings.timeOut)
                    .toTimeString()
                    .split(" ")[0];
                  // console.log("out: ", outTime);

                  if (time < outTime) {
                    this.currentStd.isEarly = true;

                    let t1 = outTime.split(":").slice(0, 2).join(":");
                    let t2 = time.split(":").slice(0, 2).join(":");
                    // console.log("out", t1, t2);

                    const date1 = new Date(`2023-01-05T${t1}:00Z`);
                    const date2 = new Date(`2023-01-05T${t2}:00Z`);
                    const diffMs = date1 - date2;

                    // Convert milliseconds to hours, minutes, and seconds
                    const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
                    const diffMins = Math.floor(
                      (diffMs % (1000 * 60 * 60)) / (1000 * 60)
                    );
                    //const diffSecs = Math.floor((diffMs % (1000 * 60)) / 1000);

                    // console.log(`early diff: ${diffHrs} hrs, ${diffMins} mins`);
                    if (diffHrs > 0) {
                      this.currentStd.delay = `${diffHrs} ${
                        diffHrs == 1 ? "hr" : "hrs"
                      } ${diffMins} ${diffMins > 1 ? "mins" : "min"} Early`;
                    } else {
                      this.currentStd.delay = `${diffMins} ${
                        diffMins > 1 ? "mins" : "min"
                      } Early`;
                    }
                  } else {
                    this.currentStd.isEarly = false;
                    // console.log("out time");
                  }
                } else {
                  //Check In
                  let index = this.allStudents.indexOf(res);
                  this.allStudents[index].toCheck = "out";

                  let inTime = new Date(this.currentStd.timings.timeIn)
                    .toTimeString()
                    .split(" ")[0];
                  // console.log("in: ", inTime);

                  if (time > inTime) {
                    this.currentStd.isLate = true;

                    let t1 = time.split(":").slice(0, 2).join(":");
                    let t2 = inTime.split(":").slice(0, 2).join(":");
                    // console.log("in", t1, t2);

                    const date1 = new Date(`2023-01-05T${t1}:00Z`);
                    const date2 = new Date(`2023-01-05T${t2}:00Z`);
                    const diffMs = date1 - date2;

                    // Convert milliseconds to hours, minutes, and seconds
                    const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
                    const diffMins = Math.floor(
                      (diffMs % (1000 * 60 * 60)) / (1000 * 60)
                    );
                    //const diffSecs = Math.floor((diffMs % (1000 * 60)) / 1000);

                    // console.log(`late diff: ${diffHrs} hrs, ${diffMins} mins`);
                    if (diffHrs > 0) {
                      this.currentStd.delay = `${diffHrs} ${
                        diffHrs == 1 ? "hr" : "hrs"
                      } ${diffMins} ${diffMins > 1 ? "mins" : "min"} Late`;
                    } else {
                      this.currentStd.delay = `${diffMins} ${
                        diffMins > 1 ? "mins" : "min"
                      } Late`;
                    }
                  } else {
                    this.currentStd.isLate = false;
                    // console.log("in time");
                  }
                }
              }
            } else {
              this.currentStd = {
                std: {
                  picture: null,
                  cls: null,
                  grNo: null,
                  name: null,
                },
                dues: null,
              };
              this.$bvToast.toast(this.$t("No student found."), {
                title: this.$t("Error!"),
                variant: "danger",
                toaster: "b-toaster-top-center",
              });
            }
            this.currentStaff = null;
          }
          this.studentLoading = false;

          this.studentID = "";
          if (this.settings.autoHide) {
            setTimeout(() => {
              this.currentStd = {
                std: {
                  picture: null,
                  cls: null,
                  grNo: null,
                  name: null,
                },
                dues: null,
              };
              this.studentID = "";
            }, this.settings.hideAfterSeconds * 1000);
          }
        }
        // general
        else {
          this.studentLoading = true;
          var obj = {
            url:
              this.$store.state.domain +
              "Attendance/LoadStudentData?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId +
              "&gr=" +
              this.studentID +
              "&userID=" +
              this.$store.state.userData.userID,
            token: this.$store.state.userData.token,
          };
          this.currentStd = await this.get(obj);
          // console.log("res:", this.currentStd);
          this.studentLoading = false;

          if (this.currentStd == "No data found.") {
            this.currentStd = {
              std: {
                picture: null,
                cls: null,
                grNo: null,
                name: null,
              },
              dues: null,
            };
            return this.$bvToast.toast(this.$t("No student found."), {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-center",
            });
          } else if (this.currentStd == "Student's profile is not active.") {
            this.currentStd = {
              std: {
                picture: null,
                cls: null,
                grNo: null,
                name: null,
              },
              dues: null,
            };
            return this.$bvToast.toast("Student's profile is not active.", {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-center",
            });
          } else {
            // this.myObj = this.currentStd.std;
            // console.log("obj:", this.myObj);

            this.items.unshift(this.currentStd);
            // console.log(this.items);
          }
          this.studentID = "";
          if (this.settings.autoHide) {
            setTimeout(() => {
              this.currentStd = {
                std: {
                  picture: null,
                  cls: null,
                  grNo: null,
                  name: null,
                },
                dues: null,
              };
              this.studentID = "";
            }, this.settings.hideAfterSeconds * 1000);
          }
        }
      }
    },
    CheckAccount() {
      var elem = this.$refs["account"];
      if (this.myObj.account == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckBalance() {
      var elem = this.$refs["balance"];
      var re = /^[0-9]+$/;
      if (re.test(this.myObj.balance) && this.myObj.balance !== 0) {
        this.myObj.balance = parseInt(this.myObj.balance);
        return (elem.state = true);
      } else {
        return (elem.state = false);
      }
    },

    hideSideBar() {
      this.visibility = false;
    },

    hideAtt() {
      this.editAtt = false;
    },

    showSmart() {
      const dt = new Date().toJSON().split("T")[0];
      this.smartObj.dt = `${dt} to ${dt}`;
      this.smartObj.dtFrom = dt;
      this.smartObj.dtTo = dt;
      this.visibility4 = true;
    },
    setSmartDate(sd, dateStr) {
      // console.log(sd, dateStr);
      if (dateStr) {
        if (sd.length > 1) {
          let date = dateStr.split(" to ");
          if (date.length == 1) {
            this.smartObj.dtFrom = date[0];
            this.smartObj.dtTo = date[0];
          } else {
            this.smartObj.dtFrom = date[0];
            this.smartObj.dtTo = date[1];
          }
        } else {
          this.smartObj.dtFrom = dateStr;
          this.smartObj.dtTo = null;
        }
      } else {
        this.smartObj.dtFrom = null;
        this.smartObj.dtTo = null;
      }
      // console.log(this.smartObj);
    },
    async saveSmart() {
      const grFormatted = this.smartObj.gr.trim().replace(/\n|,/g, " ");
      if (
        grFormatted.trim() == "" ||
        !this.smartObj.dtFrom ||
        !this.smartObj.dtTo ||
        this.smartObj.status == ""
      ) {
        this.$bvToast.toast(this.$t("Please enter the details properly"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        this.smartObj.gr = grFormatted;
        // console.log(this.smartObj);
        this.request = true;
        // SmartAttendance
        const payload = {
          status: this.smartObj.status,
          gr: grFormatted,
          dt: this.smartObj.dtFrom,
          dtTo: this.smartObj.dtTo,
        };
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Attendance/SmartAttendanceRange?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: payload,
          message: "Attendance saved successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        if (status) {
          this.visibility4 = false;
        }
      }
    },

    showSettings() {
      this.visibility = true;
    },
    async LoadSettings() {
      var obj = {
        url:
          this.$store.state.domain +
          "AttendanceSettings/LoadData?campusID=" +
          this.$store.state.userData.cId +
          "&db=" +
          this.$store.state.userData.db,
        token: this.$store.state.userData.token,
      };
      let result = await this.get(obj);

      if (result == null) {
        this.settings = {
          id: 0,
          campusID: this.$store.state.userData.cId,
          notifyArrival: false,
          notifyDeparture: false,
          appNotificationArrival: false,
          appNotificationDeparture: false,
          showDues: false,
          showRecent: false,
          autoHide: false,
          hideAfterSeconds: 5,
          attendanceMode: "",
        };
      } else {
        this.settings = result;
      }
      // console.log("set", this.settings);
    },
    async LoadClasses() {
      var obj = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClasses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId +
          "&dID=0",
        token: this.$store.state.userData.token,
      };
      this.classes = await this.get(obj);
      // console.log("class", this.classes);
      this.classes.forEach((el) => {
        this.classesOptions.push(el.cls);
      });
    },
    async LoadDepartments() {
      var obj = {
        url:
          this.$store.state.domain +
          "departments?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.departments = await this.get(obj);
      if (this.departments.length > 0) {
        this.departments.unshift({ name: "All Departments", id: 0 });
      }
    },
    async LoadSections() {
      var obj = {
        url:
          this.$store.state.domain +
          "Sections?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.sections = await this.get(obj);
      // console.log("sections", this.sections);
    },
    async saveSettings() {
      this.request = true;
      let x = parseInt(this.settings.hideAfterSeconds);
      this.settings.hideAfterSeconds = !x ? 5 : x;

      var status = await this.post({
        url:
          this.$store.state.domain +
          "AttendanceSettings/Save?db=" +
          this.$store.state.userData.db,
        body: this.settings,
        message: "Settings saved successfully.",
        context: this,
        token: this.$store.state.userData.token,
      });
      this.request = false;
      if (status) {
        this.visibility = false;
        this.LoadSettings();
      }
    },
    async saveAttendance() {
      this.request = true;
      // this.attendance.obj.date = this.datepickr + this.timePicker;
      this.attendance.obj.date = new Date().toJSON();
      var status = await this.put({
        url:
          this.$store.state.domain +
          "Attendance/id=" +
          this.attendance.obj.id +
          "?db=" +
          this.$store.state.userData.db,
        body: this.attendance.obj,
        message: "Attendance updated successfully.",
        context: this,
        token: this.$store.state.userData.token,
      });
      this.request = false;
      if (status) {
        this.editAtt = false;
        this.loadgrid();
      }
    },

    // Update modal methods
    openUpdate() {
      this.updateObj = {
        friday: false,
        saturdaySunday: false,
        clsIDs: [0],
        date: "",
        dateSS: "",
      };
      this.$bvModal.show("modal-update");
    },

    setUpdateClass() {
      if (this.updateObj.clsIDs.at(-1) == 0) {
        this.updateObj.clsIDs = [0];
      } else {
        this.updateObj.clsIDs = this.updateObj.clsIDs.filter((el) => el != 0);
      }
    },

    async saveUpdate() {
      // Validation
      if (
        this.updateObj.friday &&
        (!this.updateObj.date || this.updateObj.clsIDs.length == 0)
      ) {
        return this.$bvToast.toast("Please select date and class for Friday", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }

      if (this.updateObj.saturdaySunday && !this.updateObj.dateSS) {
        return this.$bvToast.toast("Please select date for Saturday-Sunday", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }

      if (!this.updateObj.friday && !this.updateObj.saturdaySunday) {
        return this.$bvToast.toast("Please select at least one option", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }

      this.savingUpdate = true;

      try {
        let successCount = 0;
        let totalRequests = 0;

        // Handle Friday request
        if (this.updateObj.friday) {
          totalRequests++;
          const fridayPayload = {
            clsIDs: this.updateObj.clsIDs[0] == 0 ? [] : this.updateObj.clsIDs,
            date: this.updateObj.date,
          };

          var fridayStatus = await this.post({
            url:
              this.$store.state.domain +
              "Attendance/MarkAsOff?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId,
            body: fridayPayload,
            message: "Friday attendance marked as off successfully!",
            context: this,
            token: this.$store.state.userData.token,
          });

          if (fridayStatus) {
            successCount++;
          }
        }

        // Handle Saturday-Sunday request
        if (this.updateObj.saturdaySunday) {
          totalRequests++;
          const saturdayPayload = {
            clsIDs: null,
            date: this.updateObj.dateSS,
          };

          var saturdayStatus = await this.post({
            url:
              this.$store.state.domain +
              "Attendance/MarkAsOff?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId,
            body: saturdayPayload,
            message: "Saturday-Sunday attendance marked as off successfully!",
            context: this,
            token: this.$store.state.userData.token,
          });

          if (saturdayStatus) {
            successCount++;
          }
        }

        this.savingUpdate = false;

        if (successCount === totalRequests) {
          this.$bvModal.hide("modal-update");
          this.$bvToast.toast("All updates completed successfully!", {
            title: "Success!",
            variant: "success",
            toaster: "b-toaster-top-center",
          });
        } else if (successCount > 0) {
          this.$bvModal.hide("modal-update");
          this.$bvToast.toast(
            `Partial success: ${successCount}/${totalRequests} requests completed`,
            {
              title: "Warning!",
              variant: "warning",
              toaster: "b-toaster-top-center",
            }
          );
        }
      } catch (error) {
        this.savingUpdate = false;
        this.$bvToast.toast("Something went wrong", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
.card {
  transition: 0.4s;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
.card-body {
  padding: 0.85rem;
}
@keyframes myfade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.input-group.set-timepicker {
  width: 140px;
}

.set-picSize {
  width: 150px !important;
  height: 150px !important;
}

.set-border {
  border: 4px solid var(--danger) !important;
}
.set-border-late {
  border: 4px solid var(--warning) !important;
}
</style>

<!-- Days Settings sidebar only (unscoped so sidebar-class width applies) -->
<style lang="scss">
#sidebar-days-settings.sidebar-days-settings,
.b-sidebar.sidebar-days-settings {
  width: 42rem !important;
  max-width: 96vw !important;
}

#sidebar-days-settings .days-settings,
.sidebar-days-settings .days-settings {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f5f6fa;
}

#sidebar-days-settings .days-settings__header,
.sidebar-days-settings .days-settings__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1.1rem 1.25rem;
  background: #fff;
  border-bottom: 1px solid #e9ecef;
}

#sidebar-days-settings .days-settings__body,
.sidebar-days-settings .days-settings__body {
  flex: 1;
  overflow-y: auto;
  padding: 1rem 1.25rem 1.5rem;
}

#sidebar-days-settings .days-settings__card,
.sidebar-days-settings .days-settings__card {
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 1rem 1.1rem;
  margin-bottom: 1rem;
}

#sidebar-days-settings .days-settings__card-title,
.sidebar-days-settings .days-settings__card-title {
  font-size: 0.98rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 0.7rem;
}

#sidebar-days-settings .days-settings__list-head,
.sidebar-days-settings .days-settings__list-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.25rem 0 0.85rem;
}

#sidebar-days-settings .days-settings__empty,
.sidebar-days-settings .days-settings__empty {
  text-align: center;
  background: #fff;
  border: 1px dashed #d1d5db;
  border-radius: 14px;
  padding: 1.75rem 1rem;
  color: #6b7280;
}

#sidebar-days-settings .days-settings__rule,
.sidebar-days-settings .days-settings__rule {
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  margin-bottom: 0.75rem;
  padding: 0.85rem 1rem;
}

#sidebar-days-settings .days-settings__rule-top,
.sidebar-days-settings .days-settings__rule-top {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.65rem;
}

#sidebar-days-settings .days-settings__meta-grid,
.sidebar-days-settings .days-settings__meta-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.55rem;
  flex: 1;
  min-width: 0;
}

#sidebar-days-settings .days-settings__meta-card,
.sidebar-days-settings .days-settings__meta-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  padding: 0.55rem 0.75rem;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
}

#sidebar-days-settings .days-settings__meta-label,
.sidebar-days-settings .days-settings__meta-label {
  display: block;
  font-size: 0.68rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6c757d;
  line-height: 1.2;
  margin-bottom: 0.2rem;
}

#sidebar-days-settings .days-settings__meta-value,
.sidebar-days-settings .days-settings__meta-value {
  display: block;
  font-size: 0.92rem;
  font-weight: 600;
  color: #212529;
  line-height: 1.3;
  word-break: break-word;
}

#sidebar-days-settings .days-settings__days-wrap,
.sidebar-days-settings .days-settings__days-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.35rem;
}

#sidebar-days-settings .days-settings__day,
.sidebar-days-settings .days-settings__day {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.2rem;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  background: #e9ecef;
  color: #495057;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.01em;
}

#sidebar-days-settings .days-settings__day--empty,
.sidebar-days-settings .days-settings__day--empty {
  background: #fff3cd;
  color: #856404;
}

#sidebar-days-settings .days-settings__actions--icons,
.sidebar-days-settings .days-settings__actions--icons {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-shrink: 0;
  margin: 0;
  padding: 0;
  border: none;
  align-self: center;
}

#sidebar-days-settings .days-settings__icon-btn,
.sidebar-days-settings .days-settings__icon-btn {
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

#sidebar-days-settings .days-settings__pager,
.sidebar-days-settings .days-settings__pager {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.35rem;
}

/* Skeleton — Days Settings only */
#sidebar-days-settings .days-settings-skeleton,
.sidebar-days-settings .days-settings-skeleton {
  width: 100%;
}

#sidebar-days-settings .days-settings-skeleton__card,
.sidebar-days-settings .days-settings-skeleton__card {
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 0.85rem 1rem;
  margin-bottom: 0.75rem;
}

#sidebar-days-settings .days-settings-skeleton__top,
.sidebar-days-settings .days-settings-skeleton__top {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.65rem;
}

#sidebar-days-settings .days-settings-skeleton__meta-grid,
.sidebar-days-settings .days-settings-skeleton__meta-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.55rem;
  flex: 1;
  min-width: 0;
}

#sidebar-days-settings .days-settings-skeleton__actions,
.sidebar-days-settings .days-settings-skeleton__actions {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-shrink: 0;
  align-self: center;
}

#sidebar-days-settings .days-settings-skeleton__chips,
.sidebar-days-settings .days-settings-skeleton__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

#sidebar-days-settings .days-settings-skeleton__bar,
.sidebar-days-settings .days-settings-skeleton__bar {
  border-radius: 8px;
  background: linear-gradient(90deg, #e2e5ea 0%, #f3f4f6 35%, #e2e5ea 70%);
  background-size: 200% 100%;
  animation: daysSettingsSkeletonShine 1.15s ease-in-out infinite;
}

#sidebar-days-settings .days-settings-skeleton__bar--meta,
.sidebar-days-settings .days-settings-skeleton__bar--meta {
  height: 52px;
  width: 100%;
  border-radius: 8px;
}

#sidebar-days-settings .days-settings-skeleton__bar--icon,
.sidebar-days-settings .days-settings-skeleton__bar--icon {
  height: 32px;
  width: 32px;
  border-radius: 8px;
  flex-shrink: 0;
}

#sidebar-days-settings .days-settings-skeleton__bar--chip,
.sidebar-days-settings .days-settings-skeleton__bar--chip {
  height: 24px;
  width: 2.5rem;
  border-radius: 4px;
}

@keyframes daysSettingsSkeletonShine {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

/* ── Student Holiday History Modal ─────────────────── */
.holiday-history-modal {
  border-radius: 14px;
  overflow: hidden;
}
.hh-modal {
  background: #fff;
  font-family: inherit;
}
.hh-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid #efeff7;
  background: #fafaff;
}
.hh-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.hh-header-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ece8ff;
  color: #7367f0;
}
.hh-header-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #2f2b3d;
  line-height: 1.2;
}
.hh-header-sub {
  font-size: 0.78rem;
  color: #8c879c;
  margin-top: 2px;
}
.hh-close-btn {
  border: 0;
  background: #f1f0f7;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #6e6b7b;
  cursor: pointer;
}
.hh-close-btn:hover {
  background: #e8e6f3;
  color: #2f2b3d;
}
.hh-filters {
  display: grid;
  grid-template-columns: 1fr 1fr minmax(160px, 1fr) auto;
  gap: 12px;
  align-items: end;
  padding: 14px 20px;
  border-bottom: 1px solid #f0f0f7;
}
.hh-filter-field label {
  display: block;
  margin-bottom: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #6e6b7b;
}
.hh-date-input {
  min-height: 38px;
  border-radius: 8px;
}
.hh-filter-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.hh-btn-search,
.hh-btn-clear {
  min-height: 38px;
  border-radius: 8px !important;
}
.hh-btn-search {
  display: inline-flex;
  align-items: center;
  padding-inline: 14px !important;
}
.hh-table-wrap {
  padding: 0 8px 8px;
  max-height: 52vh;
  overflow: auto;
}
.holiday-history-table {
  margin-bottom: 0;
}
.holiday-history-table thead th.hh-th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #fff;
  border-top: 0;
  border-bottom: 1px solid #efeff7;
  color: #8c879c;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
  padding: 12px 14px;
}
.holiday-history-table tbody td.hh-td {
  padding: 12px 14px;
  vertical-align: middle;
  border-top: 1px solid #f5f4fa;
  color: #4b465c;
  font-size: 0.875rem;
}
.hh-th-actions,
.hh-td-actions {
  width: 56px;
  text-align: center !important;
}
.hh-campus {
  font-weight: 600;
  color: #2f2b3d;
}
.hh-date-chip {
  display: inline-flex;
  padding: 3px 8px;
  border-radius: 6px;
  background: #f3f2f7;
  color: #5e5873;
  font-size: 0.8rem;
  white-space: nowrap;
}
.hh-reason {
  display: inline-block;
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.hh-status-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}
.hh-status-badge {
  font-size: 0.72rem;
  font-weight: 600;
}
.hh-status-meta {
  font-size: 0.68rem;
  color: #8c879c;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.hh-dept-pill {
  display: inline-flex;
  padding: 3px 9px;
  border-radius: 999px;
  background: #eefbf3;
  color: #28c76f;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}
.hh-muted {
  color: #8c879c;
  white-space: nowrap;
}
.hh-actions {
  display: flex;
  justify-content: center;
}
.hh-del-btn {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 50%;
  background: #fdeeee;
  color: #ea5455;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.hh-del-btn:hover:not(:disabled) {
  background: #ea5455;
  color: #fff;
}
.hh-del-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
.hh-busy,
.hh-empty {
  text-align: center;
  padding: 2rem 1rem;
  color: #8c879c;
}
.hh-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 20px 16px;
  border-top: 1px solid #efeff7;
  background: #fafaff;
}
.hh-footer-count {
  font-size: 0.8rem;
  color: #8c879c;
}
@media (max-width: 768px) {
  .hh-filters {
    grid-template-columns: 1fr;
  }
}

/* ── Holiday Summary Modal ─────────────────────────── */
.hs-modal {
  border-radius: 12px;
  overflow: hidden;
  font-family: inherit;
  background: #fff;
}
.hs-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 18px 22px 14px;
  border-bottom: 1px solid #f0f0f7;
  background: #fafafe;
}
.hs-header-left {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.hs-header-icon {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  background: #e6f9ee;
  color: #28a745;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hs-header-icon--warn {
  background: #fff4e5;
  color: #ff9f43;
}
.hs-header-title {
  font-size: 0.93rem;
  font-weight: 700;
  color: #2d2d3a;
  line-height: 1.3;
  margin-bottom: 6px;
}
.hs-header-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
.hs-meta-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.71rem;
  font-weight: 500;
  color: #6e6b7b;
  background: #f0eef8;
  border-radius: 20px;
  padding: 2px 9px;
}
.hs-meta-badge--reason {
  background: #fff3e0;
  color: #d87c2a;
}
.hs-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #bbb;
  padding: 4px;
  border-radius: 6px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, color 0.15s;
  flex-shrink: 0;
}
.hs-close-btn:hover {
  background: #eeeef5;
  color: #555;
}
.hs-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border-bottom: 1px solid #f0f0f7;
}
.hs-stat {
  padding: 16px 8px;
  text-align: center;
  border-right: 1px solid #f0f0f7;
}
.hs-stat:last-child {
  border-right: none;
}
.hs-stat-num {
  font-size: 1.65rem;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 4px;
}
.hs-stat-lbl {
  font-size: 0.68rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #b0aec0;
}
.hs-stat--green .hs-stat-num {
  color: #28c76f;
}
.hs-stat--blue .hs-stat-num {
  color: #00cfe8;
}
.hs-stat--orange .hs-stat-num {
  color: #ff9f43;
}
.hs-stat--purple .hs-stat-num {
  color: #7367f0;
}
.hs-message {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 12px 22px 0;
  padding: 10px 12px;
  border-radius: 8px;
  background: #f3f2fd;
  color: #5e5873;
  font-size: 0.8rem;
  line-height: 1.4;
}
.hs-message--warn {
  background: #fff8ef;
  color: #9a6700;
  border: 1px solid #ffe2b8;
}
.hs-footer {
  display: flex;
  justify-content: flex-end;
  padding: 12px 22px 14px;
  border-top: 1px solid #f0f0f7;
  background: #fafafe;
}
.hs-done-btn {
  padding: 6px 22px !important;
  font-size: 0.82rem !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
}
</style>
